import * as actions from './redux/actions';
import * as commonActions from '../../common/redux/actions';
import * as homeActions from '../../home/redux/actions';
import * as serviceActions from '../PasajebusServiceList/redux/actions';

import {
  KuposCheckbox,
  KuposErrorSuccessModal,
  KuposModalWithButtons,
  PaymentOptions,
} from '../../common';
import React, { Component, Fragment, PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import ApiUrls from '../../../services/apiUrls';
import { AppData } from '../../../services';
import BookingSuccess from './BookingSuccess/BookingSuccess';
import CommonService from '../../../services/commonService';
import ConveniosList from './ConveniosList/ConveniosList';
import DateService from '../../../services/dateService';
import KuposInput from '../../common/KuposInput';
import KuposSelectBox from '../../common/KuposSelectBox';
import KuposSteps from '../../common/KuposSteps';
import PaymentRightSideBar from './PaymentRightSideBar/PaymentRightSideBar';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// import * as serviceActions from '../../pb-service-list/redux/actions';

class BookingInput extends PureComponent {
  // const {selectedSeatsToBook,countries,idCardTypes,name, countryName, cardNumber, nameError,cardNumberError onNameChange, onCountryChange, onIdCardChange, onIdCardNumberChange,onInputBlur} = this.props;
  constructor(props) {
    super(props);
    this.state = {
      pullmanDiscountError: null,
    };
  }

  PropTypes = {
    t: PropTypes.func,
  };

  nameChanged = (text, seat) => {
    this.props.onNameChange(text, seat);
  };

  last_nameChanged = (text, seat) => {
    this.props.onLastNameChange(text, seat);
  };
  inputBlur = (text, seat, inp) => {
    this.props.onInputBlur(text, seat, inp);
  };
  countryChanged = (val, seat) => {
    this.props.onCountryChange(val, seat);
  };
  idCardChanged = (val, seat) => {
    this.props.onIdCardChange(val, seat);
  };
  idCardNumberChanged = (text, seat) => {
    this.props.onIdCardNumberChange(text, seat);
  };

  seatInputs = (seat, i) => {
    const { t } = this.props;
    let passengerDetails = CommonService.copyObject(this.props.passengerDetails);
    let passenger =
      passengerDetails && passengerDetails.length
        ? passengerDetails.find(it => seat.number == it.seatNumber)
        : null;

    // return !seat.is_pet_seat ? (

    return (
      <Fragment>
        <tr key={i} className="passenger-input font10">
          <td className="seat-number-input">
            <div className="kupos-border primary-text bold-text" style={{ cursor: 'default' }}>
              {seat.number}
            </div>
          </td>
          <td className="nationality-input">
            <KuposSelectBox
              options={this.props.countries}
              selectedOption={passenger ? passenger.nationality : {}}
              onChange={val => this.countryChanged(val, seat)}
              height={40}
              showAll={true}
              readonly={true}
              disabled={this.props.disabled}
              t={t}
              marginTop={0.1}
              key={passenger && passenger.nationality && passenger.nationality.value}
            />
          </td>
          <td className="doc-input">
            <KuposSelectBox
              options={this.props.idCardTypes}
              selectedOption={passenger ? passenger.idCardType : {}}
              onChange={val => this.idCardChanged(val, seat)}
              height={40}
              showAll={true}
              readonly={true}
              disabled={this.props.disabled}
              t={t}
              marginTop={0.1}
              key={passenger && passenger.idCardType && passenger.idCardType.value}
            />
          </td>
          <td className="rut-input">
            <KuposInput
              className="kupos-border"
              type="text"
              // placeholder= {t('PASSENGER_DETAILS.DOC_NUMBER')}
              value={passenger ? passenger.idCardNumber : ''}
              onChange={text => this.idCardNumberChanged(text, seat)}
              onBlur={text => this.inputBlur(text, seat, 'card_number')}
              disabled={this.props.disabled}
              error={
                this.props.cardNumberError && this.props.cardNumberError[seat.number] ? true : false
              }
              errorMessage={
                this.props.cardNumberError && this.props.cardNumberError[seat.number]
                  ? t(this.props.cardNumberError[seat.number].message)
                  : ''
              }
            />
          </td>
          <td className="name-input">
            <KuposInput
              className="kupos-border"
              type="text"
              // placeholder={t('PASSENGER_DETAILS.NAME')}
              value={passenger ? passenger.name : ''}
              onChange={text => this.nameChanged(text, seat)}
              onBlur={text => this.inputBlur(text, seat, 'name')}
              disabled={this.props.disabled}
              error={this.props.nameError && this.props.nameError[seat.number] ? true : false}
              errorMessage={
                this.props.nameError && this.props.nameError[seat.number]
                  ? t(this.props.nameError[seat.number].message)
                  : ''
              }
            />
          </td>
          <td className="name-input">
            <KuposInput
              className="kupos-border"
              type="text"
              // placeholder={t('PASSENGER_DETAILS.SURNAME')}
              value={passenger ? passenger.last_name : ''}
              onChange={text => this.last_nameChanged(text, seat)}
              disabled={this.props.disabled}
              onBlur={text => this.inputBlur(text, seat, 'last_name')}
              error={
                this.props.last_nameError && this.props.last_nameError[seat.number] ? true : false
              }
              errorMessage={
                this.props.last_nameError && this.props.last_nameError[seat.number]
                  ? t(this.props.last_nameError[seat.number].message)
                  : ''
              }
            />
          </td>
        </tr>
      </Fragment>
    );
    // ) : null;
  };

  render() {
    return (
      <Fragment>
        <table>
          <tbody>
            <tr className="passenger-input-heading bold-text font10">
              <th className="seat-number-input">
                N<sup>o</sup>{' '}
              </th>
              <th className="nationality-input">{this.props.t('PASSENGER_DETAILS.NATIONALITY')}</th>
              <th className="doc-input">{this.props.t('PASSENGER_DETAILS.DOCUMENT')}</th>
              <th className="rut-input">{this.props.t('PASSENGER_DETAILS.DOC_NUM_DEGREE')}</th>
              <th className="name-input">{this.props.t('PASSENGER_DETAILS.NAME')}</th>
              <th className="last_name-input">{this.props.t('PASSENGER_DETAILS.SURNAME')}</th>
            </tr>
            {this.props.selectedSeatsToBook.map((seat, i) =>
              !seat.is_pet_seat ? this.seatInputs(seat, i) : null,
            )}
          </tbody>
        </table>
      </Fragment>
    );
  }
}

class DefaultPage extends Component {
  static propTypes = {
    pbServiceList: PropTypes.object,
    home: PropTypes.object,
    common: PropTypes.object,
    pbPaymentDetails: PropTypes.object,
    actions: PropTypes.object,
  };
  countrieCodes = [];
  paymentGatewayList;
  countries = [];
  idCardTypes = [];
  idCardTypesReturn = [];

  constructor(props) {
    super(props);
    try {
      const { status, pnrNumber } = this.props.match.params;
      let fromPaymentGateway = localStorage.getItem('paymentGatewayOpened');
      if (fromPaymentGateway && !status) {
        this.props.history.replace(``, null);
        let homeData = JSON.parse(localStorage.getItem('home'));
        if (homeData && homeData.pbSourceCity && homeData.pbDestinationCity) {
          let source = homeData.pbSourceCity.label
            .toLowerCase()
            .replace(/-/g, '_')
            .replace(/ /g, '-')
            .replace(/_/g, '--');
          let dest = homeData.pbDestinationCity.label
            .toLowerCase()
            .replace(/-/g, '_')
            .replace(/ /g, '-')
            .replace(/_/g, '--');
          let path = `/${
            CommonService.isTrain() ? 'es/pasajes-tren' : 'es/pasajes-bus'
          }/${source}/${dest}/${homeData.onwardPBDate}`;
          if (homeData.returnPBDate) {
            path = `/${
              CommonService.isTrain() ? 'es/pasajes-tren' : 'es/pasajes-bus'
            }/${source}/${dest}/${homeData.onwardPBDate}/${homeData.returnPBDate}/1`;
          }
          this.props.history.push(path);
        } else {
          this.props.history.push(`/booking/failure`);
        }
      }

      this.initialize();

      // this.props.actions.setBookingJSONDetails(null);
    } catch (e) {
      console.log(e);
      this.props.history.push(`/`);
    }
    //  this.state.idCardTypes = this.idCardTypes;
    //  this.state.idCardTypesReturn = this.idCardTypesReturn;

    this.state = {
      oneClickCardTypes: null,
      cardChecked: false,
      convenioType: 'RUT',
    };

    //Get one click cards
    this.props.actions.apiCall({ url: AppData.BASE_URL + 'api/my_cards_list', type: 'home' }).then(
      res => this.onOneClickCardsFetch(res),
      err => this.onOneClickCardsFetch(err),
    );

    let isTSService = sessionStorage.getItem('isTSService') === 'true' ? true : false;
    let isTSServiceRound = sessionStorage.getItem('isTSServiceRound') === 'true' ? true : false;

    console.log('testing isTSService', isTSService);
    console.log('testing isTSServiceRound', isTSServiceRound);

    this.loadConvenios();
    // if (this.home.returnPBDate) {
    //   if (!isTSService && !isTSServiceRound) {
    //     this.loadConvenios();
    //   }
    // } else if (!isTSService) {
    //   this.loadConvenios();
    // }
  }

  loadConvenios = () => {
    this.props.actions.getConvenios().then(
      res => {
        //  this.props.setConvenios(res.data.data);
      },
      err => {},
    );
  };

  onOneClickCardsFetch = result => {
    if (result && result.data && result.data.card_details) {
      this.setState({ myCards: result.data.card_details });
    }

    this.setState({ showPaymentsOptions: true });
    this.loadOperatorTnc();
  };

  initialize = () => {
    const { status, pnrNumber } = this.props.match.params;
    if (status) {
      localStorage.removeItem('paymentGatewayOpened');
      localStorage.removeItem('pbServiceList');

      this.props.actions.setServiceOnward({
        coachLayoutJson: null,
        originStageDetails: null,
        destinationStageDetails: null,
        boardingStage: null,
        droppingStage: null,
        route: null,
      });
      this.props.actions.setServiceReturn({
        coachLayoutJson: null,
        originStageDetails: null,
        destinationStageDetails: null,
        boardingStage: null,
        droppingStage: null,
        route: null,
      });
      this.props.actions.selectSeatOnward({
        totalBookingAmount: 0,
        netBookingAmount: 0,
        discountAmount: 0,
        selectedSeatsToBook: null,
        selectedSeatsNumbers: null,
        selectedSeatTypes: null,
      });
      this.props.actions.selectSeatReturn({
        totalBookingAmount: 0,
        netBookingAmount: 0,
        discountAmount: 0,
        selectedSeatsToBook: null,
        selectedSeatsNumbers: null,
        selectedSeatTypes: null,
      });
      if (this.countdownInterVal) clearInterval(this.countdownInterVal);
    }
    let metaData;
    if (!this.props.home.metaData || !this.props.home.onwardPBDate) {
      this.home = CommonService.getLocal('home');
      if (this.home) {
        metaData = this.home.metaData;
        this.pbServiceList = CommonService.getLocal('pbServiceList');
        if (this.pbServiceList) this.setHomeAndServiceState(this.home, this.pbServiceList);
        else {
          if (
            this.props.pbServiceList.bookingDetailsOnward.selectedSeatsNumbers ||
            this.pbServiceList
          ) {
            CommonService.setLocal('pbServiceList', this.props.pbServiceList);
          } else if (!status) {
            this.props.history.push(`/`);
          }
        }
      } else if (!status) {
        this.props.history.push(`/`);
      }
    } else {
      this.home = this.props.home;
      metaData = this.props.home.metaData;
      this.pbServiceList = CommonService.getLocal('pbServiceList');
      if (!this.pbServiceList) {
        CommonService.setLocal('pbServiceList', this.props.pbServiceList);
        this.pbServiceList = this.props.pbServiceList;
        if (
          !this.props.pbServiceList.bookingDetailsOnward.selectedSeatsNumbers &&
          !this.pbServiceList &&
          !status
        ) {
          this.props.history.push(`/`);
        }
      }
    }
    if (metaData) {
      for (let c of metaData.country_codes) {
        this.countrieCodes.push({
          value: c,
          label: '+' + c,
        });
      }
      for (let c in metaData.nationality_list) {
        this.countries.push({
          value: metaData.nationality_list[c],
          label: c.substring(0, 3).toUpperCase(),
        });
      }
      for (let c in metaData.id_card_types) {
        if (this.idCardTypes.length <= 1) {
          this.idCardTypes.push({
            value: metaData.id_card_types[c],
            label: c,
          });
        }
      }
      this.paymentGatewayList = CommonService.copyObject(metaData.payment_gate_way_list);
      this.paymentGatewayListV1 = CommonService.copyObject(metaData.payment_gate_way_list_v1);
    }
    this.status = status;
    this.pnrNumber = pnrNumber;
    this.timer = sessionStorage.getItem('paymentCounter');
    this.state = {
      mobileError: null,
      emailError: null,
      confirmEmailError: null,
      selectedPaymentGateway: null,
      showBookingConfirmModal: false,
      wallet: false,
      walletMoney: 0,
      confirmTabSelected: 1,

      nameError: {},
      last_nameError: {},
      cardNumberError: {},
      nameReturnError: {},
      last_nameReturnError: {},
      cardNumberReturnError: {},
      idCardTypes: [],
      idCardTypesReturn: [],
      status: status,
      countdown: '09:00',
      corporateDiscountState: null,
    };
    let contactDetails = {
      countryCode: this.countrieCodes && this.countrieCodes[0] ? this.countrieCodes[0].name : '',
      mobile: this.props.common.loginData ? this.props.common.loginData.phone : null,
      email: this.props.common.loginData ? this.props.common.loginData.email : null,
      // confirmEmail: this.props.common.loginData ? this.props.common.loginData.email : null,
      confirmEmail: null,
    };
    this.props.actions.setContactDetails(contactDetails);
    let passengerDetailsOnward = [];
    let i = 0;
    let pbServiceList = this.pbServiceList;
    if (
      pbServiceList &&
      pbServiceList.bookingDetailsOnward &&
      pbServiceList.bookingDetailsOnward.selectedSeatsToBook
    ) {
      for (let s of pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
        passengerDetailsOnward.push({
          floorNo: s.floor_no || s.floor_no === 0 ? s.floor_no + 1 : null,
          seatNumber: s.number,
          name: i == 0 && this.props.common.loginData ? this.props.common.loginData.name : null,
          last_name:
            i == 0 && this.props.common.loginData ? this.props.common.loginData.last_name : null,
          nationality: this.countries[0],
          idCardType:
            i == 0 && this.props.common.loginData && Object.keys(this.props.common.loginData).length
              ? this.idCardTypes.find(it => it.value == this.props.common.loginData.identity_type)
              : this.idCardTypes.find(it => it.value == 7),
          idCardNumber:
            i == 0 && this.props.common.loginData && Object.keys(this.props.common.loginData).length
              ? this.props.common.loginData.identity_val
              : null,
          fare: s.fare,
          o_fare: s.o_fare,
          isPeatSeat: s && s.is_pet_seat ? true : false,
        });
        //  let cardTypes = [];
        //  for(let c in metaData.id_card_types){
        //      cardTypes.push({
        //          value:metaData.id_card_types[c],
        //          id:metaData.id_card_types[c],
        //          label:c,
        //          name:c,
        //          selected:(this.props.common.loginData && i == 0) ? (metaData.id_card_types[c] == this.props.common.loginData.identity_type) : (metaData.id_card_types[c] == 7)
        //      })
        //  }
        //  this.idCardTypes.push(cardTypes);
        i++;
      }
    }
    i = 0;
    this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);

    if (
      pbServiceList &&
      pbServiceList.bookingDetailsOnward &&
      pbServiceList.bookingDetailsOnward.selectedSeatsToBook
    ) {
      setTimeout(() => {
        for (let seat of pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
          if (seat.is_pet_seat) {
            let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
            let passenger2 = passengerDetailsOnward.find(
              it => seat.associated_seat == it.seatNumber,
            );
            if (passenger2) {
              passenger2.name = passenger.name;
              passenger2.last_name = passenger.last_name;
              passenger2.nationality = passenger.nationality;
              passenger2.idCardType = passenger.idCardType;
              passenger2.idCardNumber = passenger.idCardNumber;
              this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
            }
          }
        }
      }, 1500);
    }

    if (!this.props.common.loginData) {
      this.fillPassengerAutoData();
    }
    if (this.home && this.home.returnPBDate) {
      let passengerDetailsReturn = [];
      if (pbServiceList && pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
        for (let s of pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
          passengerDetailsReturn.push({
            floorNo: s.floor_no || s.floor_no === 0 ? s.floor_no + 1 : null,
            seatNumber: s.number,
            name: null,
            nationality: this.countries[0],
            idCardType: this.idCardTypes.find(it => it.value == 7),
            idCardNumber: null,
            fare: s.fare,
            o_fare: s.o_fare,
            isPeatSeat: s && s.is_pet_seat ? true : false,
          });
          //  let cardTypes = [];
          //  for(let c in metaData.id_card_types){
          //      cardTypes.push({
          //          value:metaData.id_card_types[c],
          //          id:metaData.id_card_types[c],
          //          label:c,
          //          name:c,
          //          selected:(metaData.id_card_types[c] == 7)
          //      })
          //  }
          //  this.idCardTypesReturn.push(cardTypes);
          i++;
        }
      }
      this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      setTimeout(() => {
        for (let seat of pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
          if (seat.is_pet_seat) {
            let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
            let passenger2 = passengerDetailsOnward.find(
              it => seat.associated_seat == it.seatNumber,
            );
            if (passenger2) {
              passenger2.name = passenger.name;
              passenger2.last_name = passenger.last_name;
              passenger2.nationality = passenger.nationality;
              passenger2.idCardType = passenger.idCardType;
              passenger2.idCardNumber = passenger.idCardNumber;
              this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
            }
          }
        }
      }, 1500);
    }
    this.updatePassengerDetailsFromCache();
    if (this.props.common.loginData) {
      let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
      let loginEmail = this.props.common.loginData.email;

      contactDetails.email = loginEmail.trim().toLowerCase();
      contactDetails.confirmEmail = loginEmail.trim().toLowerCase();
      this.props.actions.setContactDetails(contactDetails);

      setTimeout(() => {
        this.callInstantDiscountAPI();
        if (this.isAllInputsValid()) {
          this.checkCorporateDiscount();
          this.callInstantDiscountAPI();
        }
      }, 1000);
    }
  };

  fillPassengerAutoData = () => {
    setTimeout(() => {
      try {
        let passengerDetailsOnward = CommonService.copyObject(
          this.props.pbPaymentDetails.passengerDetailsOnward,
        );
        passengerDetailsOnward[0].name = this.props.common.loginData
          ? this.props.common.loginData.name
          : null;
        passengerDetailsOnward[0].last_name = this.props.common.loginData
          ? this.props.common.loginData.last_name
          : null;
        (passengerDetailsOnward[0].idCardType =
          this.props.common.loginData && Object.keys(this.props.common.loginData).length
            ? this.idCardTypes.find(it => it.value == this.props.common.loginData.identity_type)
            : this.idCardTypes.find(it => it.value == 7)),
          (passengerDetailsOnward[0].idCardNumber =
            this.props.common.loginData && Object.keys(this.props.common.loginData).length
              ? this.props.common.loginData.identity_val
              : null);
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);

        let contactDetails = {
          countryCode:
            this.countrieCodes && this.countrieCodes[0] ? this.countrieCodes[0].name : '',
          mobile: this.props.common.loginData ? this.props.common.loginData.phone : null,
          email: this.props.common.loginData ? this.props.common.loginData.email : null,
          confirmEmail: this.props.common.loginData ? this.props.common.loginData.email : null,
          // confirmEmail: null,
        };
        this.props.actions.setContactDetails(contactDetails);
        CommonService.loginCallbackFunction = null;
      } catch (e) {
        console.log(e);
      }

      if (this.props.common.loginData) {
        setTimeout(() => {
          if (this.isAllInputsValid()) {
            this.checkCorporateDiscount();
            this.callInstantDiscountAPI();
          }
        }, 1000);
      }
    }, 300);
  };

  setHomeAndServiceState = (home, service) => {
    // this.props.actions.setOnwardPbDate(home.metaData);
    this.props.actions.setHomeState(home);
    this.props.actions.setServiceState(service);
  };

  componentDidMount() {
    window.scroll({
      top: 5,
      left: 0,
    });
    window.scroll({
      top: 0,
      left: 0,
    });

    // if user has selected no seat then go back
    const { status, pnrNumber } = this.props.match.params;

    if (!status) {
      if (
        !(
          this.props.pbServiceList &&
          this.props.pbServiceList.bookingDetailsOnward &&
          this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
        )
      ) {
        this.props.history.goBack();
      }

      // if user has selected no seat then go back
      if (this.props.home.returnPBDate) {
        if (
          !(
            this.props.pbServiceList.bookingDetailsReturn &&
            this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
          )
        ) {
          this.props.history.goBack();
        }
      }
    }

    setTimeout(() => {
      this.initialize();
      this.setState({
        oneClickCardTypes: this.props.home.metaData ? this.props.home.metaData.card_type : null,
      });
      this.setState({
        isOneClickEnabled: this.props.home.metaData
          ? this.props.home.metaData.is_oneclick_card_enable
          : null,
      });
    }, 500);

    if (!this.props.common.loginData) {
      let contactDetails = {
        countryCode: '',
        mobile: '',
        email: '',
        confirmEmail: '',
      };

      try {
        let passengerDetailsOnward = CommonService.copyObject(
          this.props.pbPaymentDetails.passengerDetailsOnward,
        );
        for (let passenger of passengerDetailsOnward) {
          passenger.name = '';
          passenger.last_name = '';
          passenger.nationality = this.countries[0];
          passenger.idCardType = this.idCardTypes.find(it => it.value == 7);
          passenger.idCardNumber = '';
        }
        if (passengerDetailsOnward[0]) {
          passengerDetailsOnward[0].name = '';
          passengerDetailsOnward[0].last_name = '';
          passengerDetailsOnward[0].identity_val = '';
        }

        this.props.actions.setContactDetails(passengerDetailsOnward);
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
        let passengerDetailsReturn = CommonService.copyObject(
          this.props.pbPaymentDetails.passengerDetailsReturn,
        );
        for (let passenger of passengerDetailsReturn) {
          passenger.name = '';
          passenger.last_name = '';
          passenger.nationality = this.countries[0];
          passenger.idCardType = this.idCardTypes.find(it => it.value == 7);
          passenger.idCardNumber = '';
        }
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      } catch (e) {
        console.log('eeeeeeeee', e);
      }
      this.props.actions.setContactDetails(contactDetails);
    }

    try {
      this.html = document.querySelector('html');
      this.html.style.scrollBehavior = 'initial';
      setTimeout(() => {
        window.scrollTo(0, 0);
        setTimeout(() => {
          this.html.style.scrollBehavior = 'smooth';
        }, 200);
      }, 200);
      const { status, pnrNumber } = this.props.match.params;
      this.status = status;
      this.pnrNumber = pnrNumber;
      if (this.status == 'success' && this.pnrNumber) {
        this.props.actions.loadTicketDetails({
          url: ApiUrls.ticketDetails(this.pnrNumber),
        });
      }
      if (!this.home || !this.home.returnPBDate) this.setupStepMenu(this.status ? 3 : 2, 1);
      else this.setupStepMenu(this.status ? 4 : 3, 2);

      if (!this.status) this.startCountDown();
      const myInput = document.querySelector('.confirm-email');
      if (myInput) {
        myInput.onpaste = function(e) {
          e.preventDefault();
        };
      }
    } catch (e) {
      console.log(e);
    }
  }

  updatePassengerDetailsFromCache = () => {
    setTimeout(() => {
      try {
        if (CommonService.passengerDetailsOnward) {
          let passengerDetailsOnward = CommonService.copyObject(
            this.props.pbPaymentDetails.passengerDetailsOnward,
          );
          let i = 0;
          for (let passenger of passengerDetailsOnward) {
            let pInfo = CommonService.passengerDetailsOnward[i];
            if (pInfo) {
              passenger.name = pInfo.name || '';
              passenger.last_name = pInfo.last_name || '';
              passenger.nationality = pInfo.nationality || passenger.nationality;
              passenger.idCardType = pInfo.idCardType || passenger.idCardType;
              passenger.idCardNumber = pInfo.idCardNumber || passenger.idCardNumber;
            }
            i++;
          }
          this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);

          let pContact = CommonService.passengerContactDetails;
          if (pContact) {
            let contactDetails = {
              countryCode: pContact.countrieCode || '',
              mobile: pContact.mobile || '',
              email: pContact.email || '',
              confirmEmail: pContact.confirmEmail || '',
            };
            this.props.actions.setContactDetails(contactDetails);
          }

          if (CommonService.passengerDetailsReturn) {
            let passengerDetailsReturn = CommonService.copyObject(
              this.props.pbPaymentDetails.passengerDetailsReturn,
            );
            let i = 0;
            for (let passenger of passengerDetailsReturn) {
              let pInfo = CommonService.passengerDetailsReturn[i];
              if (pInfo) {
                passenger.name = pInfo.name || '';
                passenger.last_name = pInfo.last_name || '';
                passenger.nationality = pInfo.nationality || passenger.nationality;
                passenger.idCardType = pInfo.idCardType || passenger.idCardType;
                passenger.idCardNumber = pInfo.idCardNumber || passenger.idCardNumber;
              }
              i++;
            }
            this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
          }
        }
      } catch (e) {}
    }, 600);
  };

  componentDidUpdate() {}

  startCountDown = () => {
    var timer = this.timer && !isNaN(this.timer) ? +this.timer : 60 * 9,
      minutes,
      seconds;
    this.countdownInterVal = setInterval(() => {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      this.setState({
        countdown: minutes + ':' + seconds,
      });

      sessionStorage.setItem('paymentCounter', timer);
      if (--timer < 0) {
        clearInterval(this.countdownInterVal);
        this.setState({ showTimeUpModal: true });
        // this.props.history.push('/');
      }
    }, 1000);
  };

  componentWillUnmount = () => {
    if (this.countdownInterVal) clearInterval(this.countdownInterVal);

    let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
    if (contactDetails) {
      contactDetails.confirmEmail = '';
      this.props.actions.setContactDetails(contactDetails);
    }
  };

  setupStepMenu = (step, type) => {
    let stepsMenu;
    if (type == 1) {
      stepsMenu = [
        { label: 'GOING', active: step == 1 },
        { label: 'PAYMENT', active: step == 2 },
        { label: 'CONFIRMATION', active: step == 3 },
      ];
    } else {
      stepsMenu = [
        { label: 'GOING', active: step == 1 },
        { label: 'RETURN', active: step == 2 },
        { label: 'PAYMENT', active: step == 3 },
        { label: 'CONFIRMATION', active: step == 4 },
      ];
    }
    this.setState({ stepsMenu: stepsMenu, status: this.status, pnrNumber: this.pnrNumber });
  };

  onInputChange = (text, inp) => {
    try {
      if (inp == 'mobile') {
        this.props.actions.setMobileError(null);
        let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
        if (contactDetails) {
          text = CommonService.phoneNumberFormat(text, 9);
          contactDetails.mobile = text;
          this.props.actions.setContactDetails(contactDetails);
        }
      } else if (inp == 'email') {
        this.props.actions.setEmailError(null);
        let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
        if (contactDetails) {
          contactDetails.email = text.trim().toLowerCase();
          this.props.actions.setContactDetails(contactDetails);
        }
      } else if (inp == 'confirmEmail') {
        this.props.actions.setConfirmEmailError(null);

        let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
        if (contactDetails) {
          contactDetails.confirmEmail = text.trim().toLowerCase();
          this.props.actions.setContactDetails(contactDetails);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  onInputBlurContact = (text, inp) => {
    try {
      if (!text) {
        if (inp == 'mobile') {
          // this.setState({
          //   mobileError: {
          //     message: 'VALIDATIONS.VALID_MOBILE',
          //   },
          // });
          this.props.actions.setMobileError({
            message: 'VALIDATIONS.VALID_MOBILE',
          });
        } else if (inp == 'email') {
          // this.setState({
          //   emailError: {
          //     message: 'VALIDATIONS.VALID_EMAIL',
          //   },
          // });
          this.props.actions.setEmailError({
            message: 'VALIDATIONS.VALID_EMAIL',
          });
        } else if (inp == 'confirmEmail') {
          // this.setState({
          //   confirmEmailError: {
          //     message: 'VALIDATIONS.VALID_CONFIRM_EMAIL',
          //   },
          // });
          this.props.actions.setConfirmEmailError({
            message: 'VALIDATIONS.VALID_CONFIRM_EMAIL',
          });
        }
      } else {
        let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);

        if (inp == 'mobile') {
          if (isNaN(text)) {
            // this.setState({
            //   mobileError: {
            //     message: 'VALIDATIONS.VALID_MOBILE',
            //   },
            // });
            this.props.actions.setMobileError({
              message: 'VALIDATIONS.VALID_MOBILE',
            });
          } else if (text.toString().length != 9) {
            // this.setState({
            //   mobileError: {
            //     message: 'VALIDATIONS.VALID_MOBILE_LENGTH_9',
            //   },
            // });
            this.props.actions.setMobileError({
              message: 'VALIDATIONS.VALID_MOBILE_LENGTH_9',
            });
          }
        } else if (inp == 'email') {
          if (!CommonService.isEMailValid(text)) {
            // this.setState({
            //   emailError: {
            //     message: 'VALIDATIONS.VALID_EMAIL',
            //   },
            // });
            this.props.actions.setEmailError({
              message: 'VALIDATIONS.VALID_EMAIL',
            });
          }
        } else if (inp == 'confirmEmail') {
          if (contactDetails.confirmEmail.toLowerCase() != contactDetails.email.toLowerCase()) {
            // this.setState({
            //   confirmEmailError: {
            //     message: 'VALIDATIONS.VALID_EMAIL_MATCH',
            //   },
            // });
            this.props.actions.setConfirmEmailError({
              message: 'VALIDATIONS.VALID_EMAIL_MATCH',
            });
          }
        }
      }

      if (this.isAllInputsValid()) {
        this.checkCorporateDiscount();
        this.callInstantDiscountAPI();
      }
    } catch (e) {
      console.log(e);
    }
  };

  loadOperatorTnc = () => {
    this.setState({ operatorTnc: '' });
    if (
      this.props.pbServiceList.selectedServiceOnward.route &&
      this.props.pbServiceList.selectedServiceOnward.route.travel_id
    )
      this.props.actions
        .apiCall({
          url: ApiUrls.travelTnc(this.props.pbServiceList.selectedServiceOnward.route.travel_id),
          type: 'home',
          method: 'GET',
        })
        .then(
          res => {
            if (res && res.data && res.data.operator)
              this.setState({
                operatorTnc: res.data.operator,
              });
          },
          err => console.log('Error from check instant discount-----', err),
        );
  };

  // --------- booking seats input on change/blur code start -------------------
  onNameChange = (text, seat) => {
    try {
      let nameError = CommonService.copyObject(this.props.pbPaymentDetails.nameError);
      if (nameError) {
        nameError[seat.number] = null;
      }
      // this.setState({
      //   nameError: nameError,
      // });
      this.props.actions.setNameError(nameError);

      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.name = text;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onNameChangeReturn = (text, seat) => {
    try {
      let nameReturnError = CommonService.copyObject(this.state.nameReturnError);
      if (nameReturnError) {
        nameReturnError[seat.number] = null;
      }
      this.setState({
        nameReturnError: nameReturnError,
      });
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.name = text;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onLastNameChange = (text, seat) => {
    try {
      let last_nameError = CommonService.copyObject(this.props.pbPaymentDetails.lastNameError);
      if (last_nameError) {
        last_nameError[seat.number] = null;
      }
      // this.setState({
      //   last_nameError: last_nameError,
      // });
      this.props.actions.setLastNameError(last_nameError);
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.last_name = text;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onLastNameChangeReturn = (text, seat) => {
    try {
      let last_nameReturnError = CommonService.copyObject(this.state.last_nameReturnError);
      if (last_nameReturnError) {
        last_nameReturnError[seat.number] = null;
      }
      this.setState({
        last_nameReturnError: last_nameReturnError,
      });
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.last_name = text;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onCountryChange = (val, seat) => {
    try {
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.nationality = val;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onCountryChangeReturn = (val, seat) => {
    try {
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.nationality = val;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onIdCardChange = (val, seat) => {
    try {
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.idCardType = val;
        passenger.idCardNumber = '';
        // let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
        let cardNumberError = CommonService.copyObject(this.props.pbPaymentDetails.rutError);

        if (cardNumberError) {
          cardNumberError[seat.number] = null;
        }
        // this.setState({
        //   cardNumberError: cardNumberError,
        // });
        this.props.actions.setRutError(cardNumberError);

        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onIdCardChangeReturn = (val, seat) => {
    try {
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.idCardType = val;
        passenger.idCardNumber = '';
        let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
        if (cardNumberReturnError) {
          cardNumberReturnError[seat.number] = null;
        }
        this.setState({
          cardNumberReturnError: cardNumberReturnError,
        });
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onIdCardNumberChange = (text, seat) => {
    try {
      if (text.trim()) {
        // let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
        let cardNumberError = CommonService.copyObject(this.props.pbPaymentDetails.rutError);

        if (cardNumberError) {
          cardNumberError[seat.number] = null;
        }
        // this.setState({
        //   cardNumberError: cardNumberError,
        // });
        this.props.actions.setRutError(cardNumberError);
      }

      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.idCardNumber = text;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
      }
    } catch (e) {
      console.log(e);
    }
  };
  onIdCardNumberChangeReturn = (text, seat) => {
    try {
      if ((text || '').trim()) {
        let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
        if (cardNumberReturnError) {
          cardNumberReturnError[seat.number] = null;
        }
        this.setState({
          cardNumberReturnError: cardNumberReturnError,
        });
      }
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (passenger) {
        passenger.idCardNumber = text;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onInputBlur = (text, seat, inp) => {
    try {
      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passenger = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
      if (!text) {
        if (inp == 'name') {
          let nameError = CommonService.copyObject(this.props.pbPaymentDetails.nameError);
          if (nameError) {
            nameError[seat.number] = {
              message: 'VALIDATIONS.VALID_NAME',
            };
          }
          // this.setState({
          //   nameError: nameError,
          // });
          this.props.actions.setNameError(nameError);
        } else if (inp == 'last_name') {
          let last_nameError = CommonService.copyObject(this.props.pbPaymentDetails.lastNameError);
          if (last_nameError) {
            last_nameError[seat.number] = {
              message: 'VALIDATIONS.VALID_SURNAME',
            };
          }
          // this.setState({
          //   last_nameError: last_nameError,
          // });

          this.props.actions.setLastNameError(last_nameError);
        } else if (inp == 'card_number') {
          // let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
          let cardNumberError = CommonService.copyObject(this.props.pbPaymentDetails.rutError);

          if (cardNumberError) {
            cardNumberError[seat.number] = {
              //  message:CommonService.isRut(passenger.idCardType,this.idCardTypes[0]) ? 'Por favor ingrese RUT válido.' : 'Por favor ingrese Pasaporte válido.'
              message: 'VALIDATIONS.VALID_PASSPORT',
            };
          }
          // this.setState({
          //   cardNumberError: cardNumberError,
          // });
          this.props.actions.setRutError(cardNumberError);
        }
      }
      if (inp == 'card_number') {
        if (text.trim() === '') {
          return;
        }
        //  if(CommonService.isRut(passenger.idCardType,this.idCardTypes[0])){
        if (!CommonService.isRutValid(passenger.idCardNumber) && passenger.idCardType.value == 7) {
          // let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
          let cardNumberError = CommonService.copyObject(this.props.pbPaymentDetails.rutError);

          if (cardNumberError) {
            cardNumberError[seat.number] = {
              message: 'VALIDATIONS.VALID_RUT_VALID',
            };
          }
          // this.setState({
          //   cardNumberError: cardNumberError,
          // });
          this.props.actions.setRutError(cardNumberError);
        }
        passenger.idCardNumber =
          passenger.idCardType.value == 7 ? CommonService.formatRut(text) : text;
        this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
        //  }

        if (text.trim() !== '') {
          let isRutAlreadyUsed = false;
          for (let i = 0; i < passengerDetailsOnward.length; i++) {
            if (
              passengerDetailsOnward[i].seatNumber !== passenger.seatNumber &&
              !passengerDetailsOnward[i].isPeatSeat
            ) {
              if (passengerDetailsOnward[i].idCardNumber === passenger.idCardNumber) {
                // let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
                let cardNumberError = CommonService.copyObject(
                  this.props.pbPaymentDetails.rutError,
                );

                if (cardNumberError) {
                  cardNumberError[seat.number] = {
                    message: 'VALIDATIONS.MULTIPLE_RUT_ERROR',
                  };
                }
                this.props.actions.setRutError(cardNumberError);

                isRutAlreadyUsed = true;
              }
            }
          }
          if (!isRutAlreadyUsed) {
            this.getPassengerDetailsInfo({
              passenger,
              text,
              passengerDetailsData: passengerDetailsOnward,
              setPassengerDetailsFunc: this.props.actions.setPassengerDetailsOnward,
            });
          }
        }
      }
      if (this.isAllInputsValid()) {
        this.checkCorporateDiscount();
        this.callInstantDiscountAPI();
      }
    } catch (e) {
      console.log(e);
    }
  };

  callInstantDiscountAPI = () => {
    console.log('callInstantDiscountAPI', this.props);
    let data = {
      ...this.props.home,
      ...this.props.pbServiceList,
      ...this.props.pbPaymentDetails,
    };

    //GET INSTANT DISCOUNT IF ANY
    let onward_seats_info = [];
    if (data.passengerDetailsOnward && data.passengerDetailsOnward.length) {
      for (let s of data.passengerDetailsOnward) {
        onward_seats_info.push({
          seat_no: (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + '',
          seat_fare: s.fare,
          id_type: s.idCardType.value,
          id_value: s.idCardNumber,
        });
      }
    }

    let return_seats_info = [];

    console.log('testing return passenger data-----', data.passengerDetailsReturn);
    if (data.passengerDetailsReturn && data.passengerDetailsReturn.length) {
      for (let s of data.passengerDetailsReturn) {
        return_seats_info.push({
          seat_no: (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + '',
          seat_fare: s.fare,
          id_type: s.idCardType.value,
          id_value: s.idCardNumber || this.props.common.loginData.identity_val,
        });
      }
    }

    let instantData = {
      amount:
        this.props.pbServiceList.bookingDetailsOnward &&
        this.props.pbServiceList.bookingDetailsOnward.netBookingAmount,
      travel_date: DateService.getTodayString('yyyy-mm-dd'),
      origin_id:
        this.props.pbServiceList.selectedService &&
        this.props.pbServiceList.selectedService.origin.id,
      destination_id:
        this.props.pbServiceList.selectedService &&
        this.props.pbServiceList.selectedService.destination.id,
      // travel_id:
      //   this.props.pbServiceList.selectedService &&
      //   this.props.pbServiceList.selectedService.travel_id,
      travel_id:
        this.props.pbServiceList.selectedServiceOnward &&
        this.props.pbServiceList.selectedServiceOnward.route
          ? this.props.pbServiceList.selectedServiceOnward.route.travel_id
          : null,
      r_travel_id:
        this.props.pbServiceList.selectedServiceReturn &&
        this.props.pbServiceList.selectedServiceReturn.route &&
        this.props.pbServiceList.selectedServiceReturn.route.travel_id,
      is_mobile_app: 'true',
      is_round_trip: data.returnPBDate ? true : false,
      depart_time:
        this.props.pbServiceList.selectedService &&
        this.props.pbServiceList.selectedService.boarding_stages[0].time,
      onward_seats_info,
      return_seats_info:
        return_seats_info && return_seats_info.length > 0 ? return_seats_info : null,
    };

    if (this.props.common.loginData) {
      instantData.customer_id = this.props.common.loginData ? this.props.common.loginData.id : null;
    }

    this.props.actions
      .apiCall({
        url: ApiUrls.applyInstantDiscount(),
        type: 'home',
        method: 'POST',
        data: instantData,
      })
      .then(
        res => this.onInstantDiscountApply(res),
        err => console.log('Error from check instant discount-----', err),
      );
  };

  onInstantDiscountApply = res => {
    if (res && res.data && res.data.status === 200) {
      this.setState({ instantDiscount: res.data });
    } else {
      this.setState({ instantDiscount: null });
    }

    if (this.props.common.loginData) {
      let amount = res.data && res.data.is_fixed_amount ? res.data.discount_amount : 0;
      this.callFTMDiscountAPI(amount);
    }
  };

  callFTMDiscountAPI = amount => {
    const data = {
      rut: this.props.common.loginData && this.props.common.loginData.identity_val,
      phone_number: this.props.common.loginData && this.props.common.loginData.phone,
      transaction_amount:
        (this.props.pbServiceList.bookingDetailsOnward &&
          this.props.pbServiceList.bookingDetailsOnward.netBookingAmount) - amount,
      travel_id:
        this.props.pbServiceList.selectedServiceOnward &&
        this.props.pbServiceList.selectedServiceOnward.route.travel_id,
    };

    this.props.actions
      .apiCall({
        url: ApiUrls.createUrl('api/services/validate_rut_for_ftm_discount'),
        type: 'home',
        method: 'POST',
        data: data,
      })
      .then(
        res => {
          console.log({ res });
          if (res && res.data && res.data.data && res.data.data.total_redemption_amount) {
            const smartMilesData = {
              smart_miles_cutomer_id: res.data.data.customer_id,
              points_to_be_redeem: res.data.data.points_to_be_redeem,
              total_redemption_amount: res.data.data.total_redemption_amount,
              redeem_smart_miles_points: true,
            };
            this.setState({ smartMilesData });
          } else {
            this.setState({ smartMilesData: null });
          }
        },
        err => console.log('Error from check instant discount-----', err),
      );
  };

  checkCorporateDiscount = () => {
    let data = {
      ...this.props.home,
      ...this.props.pbServiceList,
      ...this.props.pbPaymentDetails,
    };

    let discountData = {
      amount: this.calculateNetFare(),
      travel_date: data.onwardPBDate,
      origin_id: data.pbSourceCity && data.pbSourceCity.value,
      destination_id: data.pbDestinationCity && data.pbDestinationCity.value,
      travel_id:
        data.selectedServiceOnward && data.selectedServiceOnward.route
          ? data.selectedServiceOnward.route.travel_id
          : null,
      is_mobile_app: 'true',
      is_round_trip: data.returnPBDate ? true : false,
      depart_time:
        data.selectedServiceOnward && data.selectedServiceOnward.route
          ? data.selectedServiceOnward.route.arr_time
          : null,
      customer_id: this.props.common.loginData && this.props.common.loginData.id,
      email:
        this.props.pbPaymentDetails.contactDetails &&
        this.props.pbPaymentDetails.contactDetails.email,
      onward_seats_info: [],
      return_seats_info: [],
    };
    let onwardSeatInfo = [];
    if (data.passengerDetailsOnward && data.passengerDetailsOnward.length) {
      for (let s of data.passengerDetailsOnward) {
        onwardSeatInfo.push({
          seat_no: (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + '',
          seat_fare: s.fare,
          id_type: s.idCardType.value,
          id_value: s.idCardNumber,
        });
      }
    }
    let returnSeatInfo = [];
    if (data.passengerDetailsReturn && data.passengerDetailsReturn.length) {
      for (let s of data.passengerDetailsReturn) {
        returnSeatInfo.push({
          seat_no: (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + '',
          seat_fare: s.fare,
          id_type: s.idCardType.value,
          id_value: s.idCardNumber,
        });
      }
    }
    discountData.onward_seats_info = onwardSeatInfo;
    discountData.return_seats_info = returnSeatInfo;
    this.props.actions
      .checkCorporateDiscount({
        url: ApiUrls.applyCorporateDiscount(data.returnPBDate),
        data: discountData,
      })
      .then(res => {
        if (res.status === 200) {
          this.setState({ corporateDiscountState: res });
        } else {
          this.setState({ corporateDiscountState: null });
        }
      });
  };

  applyPullmanDiscount = (rut, discountItem) => {
    let isTSService = sessionStorage.getItem('isTSService') === 'true' ? true : false;
    let isTSServiceRound = sessionStorage.getItem('isTSServiceRound') === 'true' ? true : false;

    this.setState({
      pullmanDiscountError: null,
      pullmanDiscountLoading: true,
      pullmanDiscountApplied: null,
    });
    let data = {};
    let totalBookingAmount = 0;
    if (isTSService || isTSServiceRound) {
      totalBookingAmount =
        totalBookingAmount + this.props.pbServiceList.bookingDetailsOnward.totalBookingAmount;
      let seatTypesO = {};
      for (let seat of this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
        let seats = this.props.pbServiceList.bookingDetailsOnward.selectedSeatsNumbers.split(',');
        if (seats) {
          let s = seats.find(it => it.indexOf('_' + seat.number) >= 0);
          seatTypesO[s] = seat.fare;
        }
      }
      let seatTypesR = null;

      if (this.props.home.returnPBDate) {
        totalBookingAmount =
          totalBookingAmount + this.props.pbServiceList.bookingDetailsReturn.totalBookingAmount;
        seatTypesR = {};
        for (let seat of this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
          let seats = this.props.pbServiceList.bookingDetailsReturn.selectedSeatsNumbers.split(',');
          if (seats) {
            let s = seats.find(it => it.indexOf('_' + seat.number) >= 0);
            seatTypesR[s] = seat.fare;
          }
        }
      }

      data = {
        id: discountItem.idConvenio,
        rut: rut,
        res_id: this.props.pbServiceList.selectedServiceOnward.route.id,
        r_res_id: this.props.home.returnPBDate
          ? this.props.pbServiceList.selectedServiceReturn.route.id
          : null,
        seat_fare_info: { o: seatTypesO, r: seatTypesR },
        tot_amount: totalBookingAmount,
        convenio_name: discountItem.convenio.descripcion,
      };
    } else {
      data = {
        id: discountItem.idConvenio,
        rut: rut,
        res_details: this.props.pbServiceList.selectedServiceOnward.selectedService.res_details,
        convenio_name: discountItem.convenio.descripcion,
        r_res_details:
          this.props.pbServiceList.selectedServiceReturn &&
          this.props.pbServiceList.selectedServiceReturn.selectedService
            ? this.props.pbServiceList.selectedServiceReturn.selectedService.res_details
            : null,
        seat_details: this.getBookingJson(),
        convenio_type: this.state.convenioType,
      };

      // -------- pre block seat data --------------------
      if (sessionStorage.getItem('preBlockResponseDataOnward')) {
        let preBlockResponseDataOnward = JSON.parse(
          sessionStorage.getItem('preBlockResponseDataOnward'),
        );
        data.block_book_resp = preBlockResponseDataOnward && preBlockResponseDataOnward.blockData;

        if (preBlockResponseDataOnward.releaseData)
          data.seat_code_hash = preBlockResponseDataOnward.releaseData.seat_code_hash;

        if (sessionStorage.getItem('preBlockResponseDataReturn')) {
          let preBlockResponseDataReturn = JSON.parse(
            sessionStorage.getItem('preBlockResponseDataReturn'),
          );
          if (data.block_book_resp) {
            data.block_book_resp.r =
              preBlockResponseDataReturn && preBlockResponseDataReturn.blockData;
          }
          if (data.seat_code_hash) {
            if (preBlockResponseDataReturn.releaseData)
              data.seat_code_hash.r = preBlockResponseDataReturn.releaseData.seat_code_hash;
          }
        }
      }
    }
    this.props.actions
      .apiCall({
        url:
          isTSService || isTSServiceRound
            ? ApiUrls.applyTsPullmanDiscount()
            : ApiUrls.applyPullmanDiscount(),
        type: 'home',
        method: 'POST',
        data: data,
      })
      .then(
        res => {
          if (res && res.data && res.data.result && res.data.result.op_total_discount > 0) {
            this.setState({ pullmanDiscountApplied: res.data.result });
          } else if (res && res.data && res.data.result && !res.data.result.seat_discount_info) {
            this.setState({
              pullmanDiscountError: `El ${this.state.convenioType ||
                'RUT'} ingresado no está asociado al convenio seleccionado`,
            });
          } else {
            this.setState({ pullmanDiscountError: 'No Discount' });
          }
          this.setState({ pullmanDiscountLoading: false });
        },
        err => {
          this.setState({
            pullmanDiscountError: `El ${this.state.convenioType ||
              'RUT'} ingresado no aplica para el convenio seleccionado.`,
            pullmanDiscountLoading: false,
          });
        },
      );
  };

  setPullmanDiscountError = data => {
    this.setState({
      pullmanDiscountError: data,
    });
  };

  isAllInputsValid = () => {
    let errorCount = 0;
    let passengerDetailsOnward = CommonService.copyObject(
      this.props.pbPaymentDetails.passengerDetailsOnward,
    );
    let passengerDetailsReturn = CommonService.copyObject(
      this.props.pbPaymentDetails.passengerDetailsReturn,
    );
    let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
    if (!contactDetails.email) {
      errorCount++;
    } else if (!CommonService.isEMailValid(contactDetails.email)) {
      errorCount++;
    }
    for (let p of passengerDetailsOnward) {
      if (!p.name) {
        errorCount++;
      }
      if (!p.last_name) {
        errorCount++;
      }
      if (!p.idCardNumber) {
        errorCount++;
      }

      if (!p.last_name) {
        errorCount++;
      }
    }
    if (this.props.home.returnPBDate) {
      for (let p of passengerDetailsReturn) {
        if (!p.name) {
          errorCount++;
        }
        if (!p.last_name) {
          errorCount++;
        }

        if (!p.idCardNumber) {
          errorCount++;
        } else {
          if (
            // p.nationality.id == 1 &&
            !CommonService.isRutValid(p.idCardNumber) &&
            p.idCardType.value == 7
          ) {
            errorCount++;
          }
        }
      }
    }

    if (errorCount > 0) {
      return false;
    }
    return true;
  };

  onInputBlurReturn = (text, seat, inp) => {
    try {
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let passenger = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
      if (!text) {
        if (inp == 'name') {
          let nameReturnError = CommonService.copyObject(this.state.nameReturnError);
          if (nameReturnError) {
            nameReturnError[seat.number] = {
              message: 'VALIDATIONS.VALID_NAME',
            };
          }
          this.setState({
            nameReturnError: nameReturnError,
          });
        } else if (inp == 'last_name') {
          let last_nameReturnError = CommonService.copyObject(this.state.last_nameReturnError);
          if (last_nameReturnError) {
            last_nameReturnError[seat.number] = {
              message: 'VALIDATIONS.VALID_SURNAME',
            };
          }
          this.setState({
            last_nameReturnError: last_nameReturnError,
          });
        } else if (inp == 'card_number') {
          let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
          if (cardNumberReturnError) {
            cardNumberReturnError[seat.number] = {
              message: 'VALIDATIONS.VALID_PASSPORT',
            };
          }
          this.setState({
            cardNumberReturnError: cardNumberReturnError,
          });
        }
      }
      if (inp == 'card_number') {
        if (text.trim() === '') {
          return;
        }
        //  if(CommonService.isRut(passenger.idCardType,this.idCardTypes[0])){
        if (!CommonService.isRutValid(passenger.idCardNumber) && passenger.idCardType.value == 7) {
          let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
          if (cardNumberReturnError) {
            cardNumberReturnError[seat.number] = {
              message: 'VALIDATIONS.VALID_RUT_VALID',
            };
          }
          this.setState({
            cardNumberReturnError: cardNumberReturnError,
          });
        }
        passenger.idCardNumber =
          passenger.idCardType.value == 7 ? CommonService.formatRut(text) : text;
        this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
        //  }

        if (text !== '') {
          this.getPassengerDetailsInfo({
            passenger,
            text,
            passengerDetailsData: passengerDetailsReturn,
            setPassengerDetailsFunc: this.props.actions.setPassengerDetailsReturn,
          });
        }
      }
      if (this.isAllInputsValid()) {
        this.checkCorporateDiscount();
        this.callInstantDiscountAPI();
      }
    } catch (e) {
      console.log(e);
    }
  };

  getPassengerDetailsInfo = ({
    passenger,
    text,
    passengerDetailsData,
    setPassengerDetailsFunc,
  }) => {
    this.props.actions
      .getPassengerInfo({
        url: ApiUrls.getPassengerInfo({
          cardType: passenger.idCardType.value,
          idCardNumber: text && text.replace(/[\.\-]/g, ''),
        }),
      })
      .then(res => {
        if (res && res.data && res.data.success && res.data.body) {
          let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
          if (!contactDetails.mobile) {
            let number = CommonService.onlyNumbers(res.data.body.phone);
            contactDetails.mobile = number;
            this.props.actions.setMobileError(null);
          }
          if (!contactDetails.email) {
            contactDetails.email = res.data.body.email;
            this.props.actions.setEmailError(null);
          }
          if (!contactDetails.confirmEmail) {
            contactDetails.confirmEmail = res.data.body.email;
            // this.setState({
            //   confirmEmailError: null,
            // });
            this.props.actions.setConfirmEmailError(null);
          }
          // confirmEmail
          // this.setState({
          //   confirmEmailError: null,
          // });
          this.props.actions.setContactDetails(contactDetails);

          if (res.data.body.name) {
            passenger.name = res.data.body.name;
            // this.setState({
            //   nameError: null,
            // });
            this.props.actions.setNameError(null);
          }
          if (res.data.body.name) {
            passenger.name = res.data.body.name.split('_')[0];
            passenger.last_name = res.data.body.name.split('_')[1]
              ? res.data.body.name.split('_')[1]
              : passenger.last_name;

            // this.setState({
            // nameError: null,
            // last_nameError: null,
            // });

            this.props.actions.setLastNameError(null);
            this.props.actions.setNameError(null);
          }
          setPassengerDetailsFunc(passengerDetailsData);
          setTimeout(() => {
            if (this.isAllInputsValid()) {
              this.checkCorporateDiscount();
              this.callInstantDiscountAPI();
            }
          }, 1000);
        }
      });
  };

  copyToReturn = () => {
    try {
      let filteredData = [];

      for (let v1 in this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
        for (let v2 in this.props.pbPaymentDetails.passengerDetailsReturn) {
          if (
            this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook[v1].number ===
              this.props.pbPaymentDetails.passengerDetailsReturn[v2].seatNumber &&
            !this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook[v1].is_pet_seat
          ) {
            filteredData.push(this.props.pbPaymentDetails.passengerDetailsReturn[v2]);
          }
        }
      }

      let passReturn = CommonService.copyObject(filteredData);
      if (!this.state.copyToReturnChecked) {
        for (let i = 0; i < this.props.pbPaymentDetails.passengerDetailsReturn.length; i++) {
          if (passReturn[i] && this.props.pbPaymentDetails.passengerDetailsOnward[i]) {
            passReturn[i].name = this.props.pbPaymentDetails.passengerDetailsOnward[i].name;
            passReturn[i].last_name = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].last_name;
            passReturn[i].nationality = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].nationality;
            passReturn[i].idCardType = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].idCardType;
            passReturn[i].idCardNumber = this.props.pbPaymentDetails.passengerDetailsOnward[
              i
            ].idCardNumber;
            this.setIdTypes(3, i);
            this.onNameChangeReturn(passReturn[i].name, { number: passReturn[i].seatNumber });
            this.onIdCardNumberChangeReturn(passReturn[i].idCardNumber, {
              number: passReturn[i].seatNumber,
            });
          }
        }
      } else {
        let i = 0;
        for (let p of passReturn) {
          p.name = '';
          p.last_name = '';
          p.nationality = this.countries[0];
          p.idCardType = this.idCardTypes[0];
          p.idCardNumber = '';
          this.setIdTypes(3, i);
          this.onNameChangeReturn(p.name, { number: p.seatNumber });
          this.onIdCardNumberChangeReturn(p.idCardNumber, { number: p.seatNumber });
          i++;
        }
      }

      for (let v1 in this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
        for (let v2 in this.props.pbPaymentDetails.passengerDetailsReturn) {
          if (
            this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook[v1].number ===
              this.props.pbPaymentDetails.passengerDetailsReturn[v2].seatNumber &&
            this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook[v1].is_pet_seat
          ) {
            passReturn.push(this.props.pbPaymentDetails.passengerDetailsReturn[v2]);
          }
        }
      }
      this.setState({
        copyToReturnChecked: !this.state.copyToReturnChecked,
        idCardTypesReturn: this.idCardTypesReturn,
      });
      this.props.actions.setPassengerDetailsReturn(passReturn);
      setTimeout(() => {
        if (this.isAllInputsValid()) {
          this.checkCorporateDiscount();
          this.callInstantDiscountAPI();
        }
      }, 150);
    } catch (e) {
      console.log(e);
    }
  };

  hasPetSeat = () => {
    for (let seat of this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
      if (seat.is_pet_seat) {
        return true;
      }
    }
    for (let seat of this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
      if (seat.is_pet_seat) {
        return true;
      }
    }
  };

  setIdTypes(idType, i) {
    // let cardTypes = [];
    // for(let c in this.props.data.metaData.id_card_types){
    //     cardTypes.push({
    //         value:this.props.data.metaData.id_card_types[c],
    //         id:this.props.data.metaData.id_card_types[c],
    //         label:c,
    //         name:c,
    //         selected: this.props.data.metaData.id_card_types[c] == idType
    //     });
    // }
    this.idCardTypesReturn[i] = idType;
  }

  onSubmit = () => {
    try {
      let contactDetails = CommonService.copyObject(this.props.pbPaymentDetails.contactDetails);
      let mobileError = null;
      let emailError = null;
      let confirmEmailError = null;

      let passengerDetailsOnward = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsOnward,
      );
      let passengerDetailsReturn = CommonService.copyObject(
        this.props.pbPaymentDetails.passengerDetailsReturn,
      );
      let nameError = CommonService.copyObject(this.props.pbPaymentDetails.nameError);
      // let last_nameError = CommonService.copyObject(this.state.last_nameError);
      let last_nameError = CommonService.copyObject(this.props.pbPaymentDetails.lastNameError);

      // let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
      let cardNumberError = CommonService.copyObject(this.props.pbPaymentDetails.rutError);

      let nameReturnError = CommonService.copyObject(this.state.nameReturnError);
      let last_nameReturnError = CommonService.copyObject(this.state.last_nameReturnError);
      let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
      let errorCount = 0;

      let onwardPassenger;

      for (let seat of this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
        if (seat.is_pet_seat) {
          let onwardPassenger = passengerDetailsOnward.find(
            it => seat.associated_seat == it.seatNumber,
          );
          let passenger2 = passengerDetailsOnward.find(it => seat.number == it.seatNumber);
          if (passenger2) {
            passenger2.name = onwardPassenger.name;
            passenger2.last_name = onwardPassenger.last_name;
            passenger2.nationality = onwardPassenger.nationality;
            passenger2.idCardType = onwardPassenger.idCardType;
            passenger2.idCardNumber = onwardPassenger.idCardNumber;
            this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
          }
        }
      }

      if (this.props.home.returnPBDate) {
        for (let seat of this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
          if (seat.is_pet_seat) {
            let passenger2 = passengerDetailsReturn.find(it => seat.number == it.seatNumber);
            let passenger = passengerDetailsReturn.find(
              it => seat.associated_seat == it.seatNumber,
            );
            if (passenger2) {
              passenger2.name = passenger ? passenger.name : onwardPassenger.name;
              passenger2.last_name = passenger ? passenger.last_name : onwardPassenger.last_name;
              passenger2.nationality = passenger
                ? passenger.nationality
                : onwardPassenger.nationality;
              passenger2.idCardType = passenger ? passenger.idCardType : onwardPassenger.idCardType;
              passenger2.idCardNumber = passenger
                ? passenger.idCardNumber
                : onwardPassenger.idCardNumber;
              this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
            }
          }
        }
      }
      if (!contactDetails.mobile) {
        mobileError = {
          message: 'VALIDATIONS.VALID_MOBILE',
        };
        errorCount++;
      }
      if (!contactDetails.email) {
        emailError = {
          message: 'VALIDATIONS.VALID_EMAIL',
        };
        errorCount++;
      } else if (!CommonService.isEMailValid(contactDetails.email)) {
        emailError = {
          message: 'VALIDATIONS.VALID_EMAIL_VALIDATION',
        };
        errorCount++;
      }
      if (contactDetails.confirmEmail != contactDetails.email) {
        confirmEmailError = {
          message: 'VALIDATIONS.VALID_EMAIL_MATCH',
        };
        errorCount++;
      }
      if (!contactDetails.confirmEmail) {
        confirmEmailError = {
          message: 'VALIDATIONS.VALID_CONFIRM_EMAIL',
        };
        errorCount++;
      }
      if (this.state.promoCodeChecked) {
        if (!this.state.promoCode) {
          errorCount++;
          this.setState({
            promoCodeError: {
              message: 'VALIDATIONS.VALID_PROMOTION',
            },
          });
        }
      }
      for (let p of passengerDetailsOnward) {
        if (!p.name) {
          if (nameError) {
            nameError[p.seatNumber] = {
              message: 'VALIDATIONS.VALID_NAME',
            };
          }
          errorCount++;
        }
        if (!p.last_name) {
          if (last_nameError) {
            last_nameError[p.seatNumber] = {
              message: 'VALIDATIONS.VALID_LAST_NAME',
            };
          }
          errorCount++;
        }
        if (!p.idCardNumber) {
          if (cardNumberError) {
            cardNumberError[p.seatNumber] = {
              message:
                p.idCardType && p.idCardType.value == 7
                  ? this.props.t('VALIDATIONS.VALID_RUT')
                  : this.props.t('VALIDATIONS.VALID_PASSPORT'),
            };
          }
          errorCount++;
        }

        if (!p.last_name) {
          if (last_nameError) {
            last_nameError[p.seatNumber] = {
              message: 'VALIDATIONS.VALID_SURNAME',
            };
          }
          errorCount++;
        }

        if (cardNumberError[p.seatNumber]) {
          errorCount++;
        }
      }
      if (this.props.home.returnPBDate) {
        for (let p of passengerDetailsReturn) {
          if (!p.name) {
            if (nameReturnError) {
              nameReturnError[p.seatNumber] = {
                message: 'VALIDATIONS.VALID_NAME',
              };
            }
            errorCount++;
          }
          if (!p.last_name) {
            if (last_nameReturnError) {
              last_nameReturnError[p.seatNumber] = {
                message: 'VALIDATIONS.VALID_SURNAME',
              };
            }
            errorCount++;
          }

          if (!p.idCardNumber) {
            if (cardNumberReturnError) {
              cardNumberReturnError[p.seatNumber] = {
                message:
                  p.idCardType && p.idCardType.value == 7
                    ? this.props.t('VALIDATIONS.VALID_RUT')
                    : this.props.t('VALIDATIONS.VALID_PASSPORT'),
              };
            }
            errorCount++;
          } else {
            if (
              // p.nationality.id == 1 &&
              !CommonService.isRutValid(p.idCardNumber) &&
              p.idCardType.value == 7
            ) {
              if (cardNumberReturnError) {
                cardNumberReturnError[p.seatNumber] = {
                  message:
                    p.idCardType == 7
                      ? this.props.t('VALIDATIONS.VALID_RUT')
                      : this.props.t('VALIDATIONS.VALID_PASSPORT'),
                };
              }
              errorCount++;
            }
          }

          if (cardNumberReturnError[p.seatNumber]) {
            errorCount++;
          }
        }
      }
      this.setState({
        // mobileError: mobileError,
        // emailError: emailError,
        // confirmEmailError: confirmEmailError,
        // nameError: nameError,
        // last_nameError: last_nameError,
        // cardNumberError: cardNumberError,
        nameReturnError: nameReturnError,
        cardNumberReturnError: cardNumberReturnError,
      });
      this.props.actions.setEmailError(emailError);
      this.props.actions.setLastNameError(last_nameError);
      this.props.actions.setNameError(nameError);
      this.props.actions.setConfirmEmailError(confirmEmailError);
      this.props.actions.setMobileError(mobileError);

      if (!this.state.tncChecked) {
        errorCount++;
      }
      if (!this.state.selectedPaymentGateway && this.calculateNetFare() > 0) {
        errorCount++;
      }
      if (errorCount <= 0) {
        setTimeout(() => {
          this.pay();
        }, 350);
      }
    } catch (e) {
      console.log(e);
    }
  };

  getSelectedPetSeatPairs = selectedSeats => {
    let petSeats = [];
    if (selectedSeats && selectedSeats.length) {
      for (let seat of selectedSeats) {
        if (seat.is_pet_seat) {
          petSeats.push([seat.number, seat.associated_seat]);
        }
      }
      return petSeats;
    }
    return null;
  };

  getBookingJson = () => {
    let data = {
      ...this.props.home,
      ...this.props.pbServiceList,
      ...this.props.pbPaymentDetails,
    };

    let bookingJson = {
      title: {},
      passenger_name: {},
      passenger_age: {},
      id_card: {},
      fare: {},
      o_fare: {},
      nationality: {},
      cash_coupon: {
        coupon_code: '',
        email: '',
      },
      op_discount: {},
      primary:
        (data.passengerDetailsOnward[0].floorNo
          ? data.passengerDetailsOnward[0].floorNo + '_'
          : '') + data.passengerDetailsOnward[0].seatNumber,
      promo_code: this.state.promoCodeApplied ? this.state.promoCode : null,
      // bima_onward_amount: 10,
      // bima_return_amount: 11,
      // net_amount: 10,
      bima_onward_amount: data.bookingDetailsOnward.netBookingAmount,
      bima_return_amount: data.bookingDetailsReturn.netBookingAmount,
      net_amount: this.calculateNetFareApi(),
      total_base_fare: this.originalBaseFare() == 0 ? this.basicFare() : this.originalBaseFare(),
      selected_seats: data.bookingDetailsOnward.selectedSeatsNumbers,
      selected_seats_r: data.bookingDetailsReturn.selectedSeatsNumbers
        ? data.bookingDetailsReturn.selectedSeatsNumbers
        : null,
      number_of_seats: data.passengerDetailsOnward.length,
      number_of_seats_r:
        data.passengerDetailsReturn && data.passengerDetailsReturn.length
          ? data.passengerDetailsReturn.length
          : null,
      boarding_at: data.selectedServiceOnward.boardingStage.id,
      return_boarding_at: data.selectedServiceReturn.boardingStage
        ? data.selectedServiceReturn.boardingStage.id
        : null,
      drop_off: data.selectedServiceOnward.droppingStage.id,
      return_drop_off: data.selectedServiceReturn.droppingStage
        ? data.selectedServiceReturn.droppingStage.id
        : null,
      reservation_id: data.selectedServiceOnward.route.id,
      return_reservation_id: data.selectedServiceReturn.route
        ? data.selectedServiceReturn.route.id
        : null,
      from: data.pbSourceCity.value,
      to: data.pbDestinationCity.value,
      origin_name: data.pbSourceCity.label,
      destination_name: data.pbDestinationCity.label,
      type: '1',
      depart: data.onwardPBDate,
      return: data.returnPBDate,
      is_charity: '0',
      referral_url: '',
      offer_coupon_details: null,
      email: data.contactDetails.email,
      phone_number: data.contactDetails.mobile,
      pay_gay_type: this.props.home.is_mot ? 45 : this.state.selectedPaymentGateway,
      country_code: data.contactDetails.countryCode,
      is_mobile_web: 3,
      use_wallet_money: this.state.wallet,
      use_virtual_money: this.state.virtual,
      // "device_details": this.props.data.deviceInfo,
      is_kupos: true,
      kupos_r_url: window.location.protocol + '//' + window.location.host,
      one_click_details: {
        card_no:
          this.state.cardChecked && this.state.selectedCard
            ? this.state.selectedCard[0].substr(12, 15)
            : '',
        card_cat:
          this.state.cardChecked && this.state.selectedCard ? this.state.selectedCard[1] : 0,
        card_type:
          this.state.cardChecked && this.state.selectedCard ? this.state.selectedCard[2] : 0,
      },
      selected_pet_seats: this.getSelectedPetSeatPairs(
        this.props.pbServiceList.bookingDetailsOnward &&
          this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook,
      ),
      selected_pet_seats_r: this.getSelectedPetSeatPairs(
        this.props.pbServiceList.bookingDetailsReturn &&
          this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook,
      ),
      // is_ts_onward: sessionStorage.getItem('isTSService'), //todo
      // is_ts_return: sessionStorage.getItem('isTSServiceRound'),

      mot_amount:
        this.state.motData && this.state.motData.mot_amount ? this.state.motData.mot_amount : null,
      discounted_amount:
        this.state.motData && this.state.motData.mot_amount
          ? this.originalBaseFare() - Number(this.state.motData.mot_amount)
          : null,
      mot_id: this.state.motData && this.state.motData.mot_id ? this.state.motData.mot_id : null,
      mot_code:
        this.state.motData && this.state.motData.mot_code ? this.state.motData.mot_code : null,
    };

    for (let s of data.passengerDetailsOnward) {
      bookingJson.title[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = 'Mr';
      bookingJson.passenger_name[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] =
        s.name + '_' + s.last_name;
      bookingJson.passenger_age[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = '35';
      bookingJson.id_card[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = {
        type: s.idCardType.value,
        number: s.idCardNumber,
      };
      // bookingJson.fare[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = 55;
      bookingJson.fare[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.fare;
      bookingJson.o_fare[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.o_fare;
      bookingJson.nationality[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] =
        s.nationality.value + '';
    }
    if (data.passengerDetailsReturn && data.passengerDetailsReturn.length) {
      let i = 0;
      for (let s of data.passengerDetailsReturn) {
        if (i === 0) {
          bookingJson.title.r = {};
          bookingJson.passenger_name.r = {};
          bookingJson.passenger_age.r = {};
          bookingJson.id_card.r = {};
          bookingJson.fare.r = {};
          bookingJson.o_fare.r = {};
          bookingJson.nationality.r = {};
        }
        bookingJson.title.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = 'Mr';
        bookingJson.passenger_name.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] =
          s.name + '_' + s.last_name;
        bookingJson.passenger_age.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = '25';
        bookingJson.id_card.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = {
          type: s.idCardType.value,
          number: s.idCardNumber,
        };
        // bookingJson.fare.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = 66;
        bookingJson.fare.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.fare;
        bookingJson.o_fare.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = s.o_fare;
        bookingJson.nationality.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] =
          s.nationality.value + '';
        i++;
      }
    }
    return bookingJson;
  };

  pushDataToGoogleAnalaytics = data => {
    let homeData = this.props.home;

    let onwardSeats = data.bookingDetailsOnward;
    let onwardService = data.selectedServiceOnward;
    let returnSeats = data.bookingDetailsReturn;
    let returnService = data.selectedServiceReturn;

    let allSelectedSeats = [];

    if (onwardSeats && onwardSeats.netBookingAmount && onwardService && onwardService.route) {
      // onwardSeats.selectedSeatsToBook.map(val => {
      allSelectedSeats.push({
        // id: Number(val.number), // Optional,
        name: CommonService.isTrain()
          ? 'train'
          : 'bus' + '-' + homeData.pbSourceCity.label + ' to ' + homeData.pbDestinationCity.label,
        brand: onwardService.route.operator_service_name,
        category: CommonService.isTrain() ? 'train' : 'bus',
        price: onwardSeats.selectedSeatsToBook[0].net_amount,
        quantity: onwardSeats.selectedSeatsToBook.length,
        variant: onwardService.route.dep_time,
      });
      // });
    }

    if (returnSeats && returnSeats.netBookingAmount && returnService && returnService.route) {
      // returnSeats.selectedSeatsToBook.map(val => {
      allSelectedSeats.push({
        // id: Number(returnSeats.selectedSeatsToBook[0].number), // Optional,
        name: CommonService.isTrain()
          ? 'train'
          : 'bus' + '-' + homeData.pbSourceCity.label + ' to ' + homeData.pbDestinationCity.label,
        brand: returnService.route.operator_service_name,
        category: CommonService.isTrain() ? 'train' : 'bus',
        price: returnSeats.selectedSeatsToBook[0].net_amount,
        quantity: returnSeats.selectedSeatsToBook.length,
        variant: returnService.route.dep_time,
      });
      // });
    }

    sessionStorage.setItem('productPurchase', JSON.stringify(allSelectedSeats));

    CommonService.pushProductCheckout(allSelectedSeats);
  };

  pay = () => {
    let maxDiscount = this.getMaxDiscount();
    let isInstanteFixedAmount = this.state.instantDiscount
      ? this.state.instantDiscount.is_fixed_amount
      : false;
    try {
      let data = {
        ...this.props.home,
        ...this.props.pbServiceList,
        ...this.props.pbPaymentDetails,
      };

      this.pushDataToGoogleAnalaytics(data);

      // let isTSService = sessionStorage.getItem('isTSService') === 'true' ? true : false;
      let isTSService = true;

      // let isTSServiceRound =
      //   sessionStorage.getItem('isTSServiceRound') &&
      //   sessionStorage.getItem('isTSServiceRound') === 'true'
      //     ? true
      //     : false;
      let isTSServiceRound = true;

      // return;
      let baseDiscount = 0;

      if (this.originalBaseFare() !== 0) {
        baseDiscount = this.originalBaseFare() - this.basicFare();
      }

      let bookingJson = this.getBookingJson();

      let tsService = {};

      if (isTSService) {
        tsService.o = true;
      }

      if (isTSServiceRound && this.props.home && this.props.home.returnPBDate) {
        tsService.r = true;
      }

      console.log('testing--- data.selectedServiceOnward', data);

      if (
        this.props.home.metaData &&
        this.props.home.metaData.non_ts_op_ids &&
        this.props.home.metaData.non_ts_op_ids.length
      ) {
        let goingServiceId = data.selectedServiceOnward.selectedService.travel_id;

        let goingPresent = this.props.home.metaData.non_ts_op_ids.includes(goingServiceId);
        if (goingPresent) {
          tsService.o = true;
        }

        if (this.props.home && this.props.home.returnPBDate) {
          let returnServiceId = data.selectedServiceReturn.selectedService.travel_id;
          let returnPresent = this.props.home.metaData.non_ts_op_ids.includes(returnServiceId);
          if (returnPresent) {
            tsService.r = true;
          }
        }
      }

      if (
        this.state.pullmanDiscountApplied &&
        this.state.pullmanDiscountApplied.op_total_discount >= baseDiscount
      ) {
        bookingJson.op_discount = this.state.pullmanDiscountApplied;
        bookingJson.is_pullman_disc = true;
      } else {
        let internalData = {
          seat_discount_info: {},
        };

        internalData.seat_discount_info.o = {};

        internalData.net_amount = this.basicFare();
        internalData.op_total_amount = this.originalBaseFare();
        internalData.op_total_discount = baseDiscount;

        for (let s of data.passengerDetailsOnward) {
          internalData.seat_discount_info.o[
            (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber
          ] = isTSService ? s.fare - s.fare : s.o_fare - s.fare < 0 ? 0 : s.o_fare - s.fare;
          // internalData.seat_discount_info.o['is_ts'] = sessionStorage.getItem('isTSService');
        }

        if (data.passengerDetailsReturn && data.passengerDetailsReturn.length) {
          internalData.seat_discount_info.r = {};
          // let i = 0;
          for (let s of data.passengerDetailsReturn) {
            // if (i === 0) {
            //   bookingJson.fare.r = {};
            // }

            // bookingJson.fare.r[(s.floorNo ? s.floorNo + '_' : '') + s.seatNumber + ''] = 66;
            internalData.seat_discount_info.r[
              (s.floorNo ? s.floorNo + '_' : '') + s.seatNumber
            ] = isTSServiceRound ? s.fare - s.fare : s.o_fare - s.fare < 0 ? 0 : s.o_fare - s.fare;
            // internalData.seat_discount_info.r['is_ts'] = sessionStorage.getItem('isTSServiceRound');
            // i++;
          }
        }

        bookingJson.op_discount = internalData;
        bookingJson.is_pullman_disc = false;
      }

      if (this.state.instantDiscount && !this.state.corporateDiscountState) {
        bookingJson.is_instant_promo = true;
        bookingJson.instant_discount = this.state.instantDiscount.discount_amount;
        bookingJson.instant_discount_id = this.state.instantDiscount.instant_discount_id;
      }

      if (this.state.corporateDiscountState && !this.state.instantDiscount) {
        bookingJson.corporate_company_id = this.state.corporateDiscountState.corporate_company_id;
        bookingJson.corporate_discount = this.state.corporateDiscountState.discount_amount;
      }

      if (this.state.corporateDiscountState && this.state.instantDiscount) {
        if (
          this.state.corporateDiscountState.discount_amount >
          this.state.instantDiscount.discount_amount
        ) {
          bookingJson.corporate_company_id = this.state.corporateDiscountState.corporate_company_id;
          bookingJson.corporate_discount = this.state.corporateDiscountState.discount_amount;
        } else {
          bookingJson.is_instant_promo = true;
          bookingJson.instant_discount = this.state.instantDiscount.discount_amount;
          bookingJson.instant_discount_id = this.state.instantDiscount.instant_discount_id;
        }
      }

      if (this.state.smartMilesData)
        (bookingJson.smart_miles =
          (this.state.smartMilesData &&
            maxDiscount <= this.state.smartMilesData.total_redemption_amount) ||
          isInstanteFixedAmount
            ? this.state.smartMilesData
            : null),
          (CommonService.passengerDetailsOnward = null);
      CommonService.passengerContactDetails = null;
      CommonService.passengerDetailsReturn = null;

      bookingJson.trip_type = data.returnPBDate ? 'roundtrip' : 'tentative';
      bookingJson.ts_service = tsService;

      // -------- pre block seat data --------------------
      if (sessionStorage.getItem('preBlockResponseDataOnward')) {
        let preBlockResponseDataOnward = JSON.parse(
          sessionStorage.getItem('preBlockResponseDataOnward'),
        );
        bookingJson.block_book_resp =
          preBlockResponseDataOnward && preBlockResponseDataOnward.blockData;

        if (preBlockResponseDataOnward.releaseData)
          bookingJson.seat_code_hash = preBlockResponseDataOnward.releaseData.seat_code_hash;

        // if (sessionStorage.getItem('preBlockResponseDataReturn')) {
        //   let preBlockResponseDataReturn = JSON.parse(
        //     sessionStorage.getItem('preBlockResponseDataReturn'),
        //   );
        //   if (bookingJson.block_book_resp) {
        //     bookingJson.block_book_resp.r =
        //       preBlockResponseDataReturn && preBlockResponseDataReturn.blockData;
        //   }
        //   if (bookingJson.seat_code_hash) {
        //     if (preBlockResponseDataReturn.releaseData)
        //       bookingJson.seat_code_hash.r = preBlockResponseDataReturn.releaseData.seat_code_hash;
        //   }
        // }
      }

      if (sessionStorage.getItem('preBlockResponseDataReturn')) {
        let preBlockResponseDataReturn = JSON.parse(
          sessionStorage.getItem('preBlockResponseDataReturn'),
        );

        bookingJson.block_book_resp = bookingJson.block_book_resp
          ? bookingJson.block_book_resp
          : {};
        bookingJson.seat_code_hash = bookingJson.seat_code_hash ? bookingJson.seat_code_hash : {};

        if (bookingJson.block_book_resp) {
          bookingJson.block_book_resp.r =
            preBlockResponseDataReturn && preBlockResponseDataReturn.blockData;
        }
        if (bookingJson.seat_code_hash) {
          if (preBlockResponseDataReturn.releaseData) {
            bookingJson.seat_code_hash.r =
              preBlockResponseDataReturn.releaseData &&
              // preBlockResponseDataReturn.releaseData.request_hash &&
              preBlockResponseDataReturn.releaseData.seat_code_hash;
          }
        }
      }

      console.log('testing bookingJson---', JSON.stringify(bookingJson));

      // return;

      this.props.actions.bookTicket({ url: ApiUrls.bookTicketV2(), data: bookingJson }).then(
        res => {
          sessionStorage.removeItem('preBlockResponseDataOnward');
          sessionStorage.removeItem('preBlockResponseDataReturn');
          localStorage.setItem('appType', CommonService.isTrain() ? 'train' : 'bus');
          console.log('response from tentativebookingapi', res);
          if (
            res &&
            res.data &&
            res.data.pnr_number &&
            res.data.html_str &&
            !res.data.invalid_seat_fare_hash
          ) {
            localStorage.setItem('paymentGatewayOpened', true);
            document.write(res.data.html_str);
          } else if (res && res.data && res.data.invalid_seat_fare_hash) {
            this.setState({
              showFareDifferenceMessage: res.invalid_seat_fare_hash
                ? res.invalid_seat_fare_hash.message
                : 'The fare of this service has changed. Do you want to proceed?',
              showFareDifferenceModal: true,
              showFareDifferenceBody: res.invalid_seat_fare_hash,
              paymentGatewayString: res.data.html_str,

              //--------------test data-----------------
              //   showFareDifferenceBody: {
              //     onward: {
              //       '35': {
              //         ui_fare: 25001.0,
              //         gds_fare: 5000.0,
              //       },
              //     },
              //     return: {
              //       '35': {
              //         ui_fare: 25001.0,
              //         gds_fare: 5000.0,
              //       },
              //     },
              //     status: 444,
              //     message: 'The fare of this service has changed. Do you want to proceed?',
              //   },
            });
          } else if (res.data.code == 'SEATS_UNAVAILABLE') {
            //SENDING CUSTOMER BACK TO COACH LAYO0UT BASED ON THE RETURN TRIP OR ONWARDF TRIP ONLY
            this.setState({
              // bookingError: res.message,
              showSuccessModel: true,
              successModelSuccess: false,
              successModelText:
                'El asiento que seleccionaste ya no está disponible. Por favor selecciona otro asiento.',
              showButton2: false,
              showButton1: true,
              onModalOkClick: () => {
                CommonService.passengerDetailsOnward = CommonService.copyObject(
                  data.passengerDetailsOnward,
                );
                CommonService.passengerContactDetails = CommonService.copyObject(
                  data.contactDetails,
                );
                if (data.returnPBDate) {
                  window.history.go(-2);
                  CommonService.passengerDetailsReturn = CommonService.copyObject(
                    data.passengerDetailsReturn,
                  );
                } else {
                  window.history.go(-1);
                }
                this.setState({
                  showSuccessModel: false,
                  successModelText: null,
                  showButton1: false,
                });
              },
            });
          } else if (res.data.message) {
            this.setState({
              bookingError: res.data.message,
              // showSuccessModel: true,
              // successModelSuccess: false,
              // successModelText: res.message,
              // showButton2: false,
              // onModalOkClick: () => {
              //   this.setState({ showSuccessModel: false, successModelText: null })
              // }
            });
          } else if (res.data.result && res.data.result.pnr_number) {
            this.props.history.push(`/booking/success/${res.data.result.pnr_number}`);
          } else if (!res.success) {
            this.props.history.push(`/booking/failure`);
          }
        },
        err => {
          this.setState({
            // bookingError: res.message,
            showSuccessModel: true,
            successModelSuccess: false,
            successModelText:
              'El asiento que seleccionaste ya no está disponible. Por favor selecciona otro asiento.',
            showButton2: false,
            showButton1: true,
            onModalOkClick: () => {
              CommonService.passengerDetailsOnward = CommonService.copyObject(
                data.passengerDetailsOnward,
              );
              CommonService.passengerContactDetails = CommonService.copyObject(data.contactDetails);
              if (data.returnPBDate) {
                window.history.go(-2);
                CommonService.passengerDetailsReturn = CommonService.copyObject(
                  data.passengerDetailsReturn,
                );
              } else {
                window.history.go(-1);
              }
              this.setState({
                showSuccessModel: false,
                successModelText: null,
                showButton1: false,
              });
            },
          });
        },
      );
    } catch (e) {
      console.log(e);
    }
  };

  walletMoneyAdded = netFare => {
    // instant discount
    try {
      if (
        this.props.common.loginData &&
        this.props.common.loginData.balances &&
        this.state.wallet
      ) {
        let money = this.props.common.loginData.balances.clp.money;
        let virtualMoney = 0;
        if (this.state.virtual) {
          virtualMoney = this.virtualMoneyAmount();
        }
        let corpDiscount = +(this.state.corporateDiscountState &&
        this.state.corporateDiscountState.type == 1
          ? this.state.corporateDiscountState.discount_amount
          : 0);
        if (money) {
          if (
            +money >
            +netFare -
              +(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0) -
              corpDiscount
          ) {
            return (
              +netFare -
              +(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0) -
              virtualMoney -
              corpDiscount
            );
          }
          return +money;
        }
      }
      return 0;
    } catch (e) {
      console.log(e);
    }
  };

  // virtualMoneyAmount = () => {
  //   try {
  //     if (
  //       this.props.home &&
  //       this.props.home.metaData &&
  //       this.props.home.metaData.allowed_virtual_limit &&
  //       this.props.common.loginData.balances.clp.credit
  //     ) {
  //       let money = +(
  //         (this.props.home.metaData.allowed_virtual_limit / 100) *
  //         this.props.common.loginData.balances.clp.credit
  //       ).toFixed(0);
  //       return money > this.basicFare() ? this.basicFare() : money;
  //     }
  //     return +((0 / 100) * this.props.common.loginData.balances.clp.credit).toFixed(0);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  virtualMoneyAmount = () => {
    try {
      if (
        this.props.home &&
        this.props.home.metaData &&
        this.props.home.metaData.allowed_virtual_limit &&
        this.props.common.loginData.balances.clp.credit
      ) {
        let money = +(
          (this.props.home.metaData.allowed_virtual_limit / 100) *
          this.basicFare()
        ).toFixed(0);

        // return money > this.basicFare() ? this.basicFare() : money;
        if (money > this.props.common.loginData.balances.clp.credit) {
          return this.props.common.loginData.balances.clp.credit;
        } else if (money > this.basicFare()) {
          return this.basicFare();
        } else {
          return money;
        }
      }
      return +((0 / 100) * this.props.common.loginData.balances.clp.credit).toFixed(0);
    } catch (e) {
      console.log(e);
    }
  };

  getMaxDiscount = () => {
    let baseDiscount = this.originalBaseFare() - this.basicFare();

    let corpDiscount = +(this.state.corporateDiscountState &&
    this.state.corporateDiscountState.type == 1
      ? this.state.corporateDiscountState.discount_amount
      : 0);

    let instantDiscount = +(this.state.instantDiscount && this.state.instantDiscount.type == 1
      ? this.state.instantDiscount.discount_amount
      : 0);

    let smartMilesDataDiscount = +(this.state.smartMilesData &&
    this.state.smartMilesData.total_redemption_amount
      ? this.state.smartMilesData.total_redemption_amount
      : 0);

    smartMilesDataDiscount =
      smartMilesDataDiscount > this.onwardBasicFare()
        ? this.onwardBasicFare()
        : smartMilesDataDiscount;
    let isInstanteFixedAmount = this.state.instantDiscount
      ? this.state.instantDiscount.is_fixed_amount
      : false;

    let newDiscount = Math.max(
      instantDiscount,
      corpDiscount,
      baseDiscount,
      isInstanteFixedAmount ? 0 : smartMilesDataDiscount,
    );
    return newDiscount + (isInstanteFixedAmount ? smartMilesDataDiscount : 0);
  };

  onwardBasicFare = () => {
    let fare =
      this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward
        ? this.props.pbServiceList.bookingDetailsOnward.netBookingAmount
        : 0;
    return fare;
  };

  basicFare = () => {
    try {
      let fare =
        this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward
          ? this.props.pbServiceList.bookingDetailsOnward.netBookingAmount
          : 0;
      if (this.props.home.returnPBDate) {
        fare +=
          this.props.pbServiceList && this.props.pbServiceList.bookingDetailsReturn
            ? this.props.pbServiceList.bookingDetailsReturn.netBookingAmount
            : 0;
      }
      return fare;
    } catch (e) {
      console.log(e);
    }
  };

  originalBaseFare = () => {
    let isTSService = sessionStorage.getItem('isTSService') === 'true' ? true : false;
    let isTSServiceRound = sessionStorage.getItem('isTSServiceRound') === 'true' ? true : false;
    try {
      let fare =
        this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward
          ? isTSService
            ? this.props.pbServiceList.bookingDetailsOnward.totalBookingAmount
            : this.props.pbServiceList.bookingDetailsOnward.totalBookingAmount
          : 0;
      if (this.props.home.returnPBDate) {
        fare +=
          this.props.pbServiceList && this.props.pbServiceList.bookingDetailsReturn
            ? isTSServiceRound
              ? this.props.pbServiceList.bookingDetailsReturn.totalBookingAmount
              : this.props.pbServiceList.bookingDetailsReturn.totalBookingAmount
            : 0;
      }
      return fare;
    } catch (e) {
      console.log(e);
    }
  };

  calculateNetFare = () => {
    try {
      let fare = this.originalBaseFare() === 0 ? this.basicFare() : this.originalBaseFare();

      let baseDiscount = 0;
      if (this.originalBaseFare()) {
        baseDiscount = this.originalBaseFare() - this.basicFare();
      }

      let virtualMoney = 0;
      if (this.state.virtual) {
        virtualMoney = this.virtualMoneyAmount();
      }
      if (this.state.wallet) {
        fare = fare - +this.walletMoneyAdded(fare) < 0 ? 0 : fare - +this.walletMoneyAdded(fare);
      }
      let netFare = fare - +(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0);
      let corpDiscount = +(this.state.corporateDiscountState &&
      this.state.corporateDiscountState.type == 1
        ? this.state.corporateDiscountState.discount_amount
        : 0);

      let instantDiscount = +(this.state.instantDiscount && this.state.instantDiscount.type == 1
        ? this.state.instantDiscount.discount_amount
        : 0);

      let discount = instantDiscount > corpDiscount ? instantDiscount : corpDiscount;

      // console.log('Testing instantDiscount----', instantDiscount);
      // console.log('Testing corpDiscount----', corpDiscount);
      // console.log('Testing baseDiscount----', baseDiscount);
      // console.log('Testing netFare----', netFare);

      let newDiscount = this.getMaxDiscount();

      if (
        this.state.pullmanDiscountApplied &&
        this.state.pullmanDiscountApplied.op_total_discount
      ) {
        // discount = this.state.pullmanDiscountApplied.op_total_discount;
        newDiscount = this.state.pullmanDiscountApplied.op_total_discount;
      }

      let motDiscount = this.props.home.is_mot && this.state.motData;

      console.log('Testing newDiscount----', newDiscount);
      console.log('Testing lastcalculated----', baseDiscount - virtualMoney - newDiscount);

      // return this.basicFare() - virtualMoney - newDiscount > 0
      //   ? this.basicFare() - virtualMoney - newDiscount
      //   : 0;
      return netFare - virtualMoney - newDiscount > 0 && !motDiscount
        ? netFare - virtualMoney - newDiscount
        : motDiscount
        ? 0
        : 0;
    } catch (e) {
      console.log(e);
    }
  };

  originalBaseFareApi = () => {
    let isTSService = sessionStorage.getItem('isTSService') === 'true' ? true : false;
    let isTSServiceRound = sessionStorage.getItem('isTSServiceRound') === 'true' ? true : false;
    try {
      let fare =
        this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward
          ? isTSService
            ? this.props.pbServiceList.bookingDetailsOnward.totalBookingAmount
            : this.props.pbServiceList.bookingDetailsOnward.oTotalBookingAmount
          : 0;
      if (this.props.home.returnPBDate) {
        fare +=
          this.props.pbServiceList && this.props.pbServiceList.bookingDetailsReturn
            ? isTSServiceRound
              ? this.props.pbServiceList.bookingDetailsReturn.totalBookingAmount
              : this.props.pbServiceList.bookingDetailsReturn.oTotalBookingAmount
            : 0;
      }
      return fare;
    } catch (e) {
      console.log(e);
    }
  };

  calculateNetFareApi = () => {
    try {
      let fare = this.originalBaseFareApi() === 0 ? this.basicFare() : this.originalBaseFareApi();

      let baseDiscount = 0;
      if (this.originalBaseFareApi()) {
        baseDiscount = this.originalBaseFareApi() - this.basicFare();
      }

      let virtualMoney = 0;
      if (this.state.virtual) {
        virtualMoney = this.virtualMoneyAmount();
      }
      if (this.state.wallet) {
        fare = fare - +this.walletMoneyAdded(fare) < 0 ? 0 : fare - +this.walletMoneyAdded(fare);
      }
      let netFare = fare - +(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0);
      let corpDiscount = +(this.state.corporateDiscountState &&
      this.state.corporateDiscountState.type == 1
        ? this.state.corporateDiscountState.discount_amount
        : 0);

      let instantDiscount = +(this.state.instantDiscount && this.state.instantDiscount.type == 1
        ? this.state.instantDiscount.discount_amount
        : 0);

      let discount = instantDiscount > corpDiscount ? instantDiscount : corpDiscount;

      // console.log('Testing instantDiscount----', instantDiscount);
      // console.log('Testing corpDiscount----', corpDiscount);
      // console.log('Testing baseDiscount----', baseDiscount);
      // console.log('Testing netFare----', netFare);

      let newDiscount = this.getMaxDiscount();

      if (
        this.state.pullmanDiscountApplied &&
        this.state.pullmanDiscountApplied.op_total_discount
      ) {
        // discount = this.state.pullmanDiscountApplied.op_total_discount;
        newDiscount = this.state.pullmanDiscountApplied.op_total_discount;
      }

      let motDiscount = this.props.home.is_mot && this.state.motData;

      console.log('Testing newDiscount----', newDiscount);
      console.log('Testing lastcalculated----', baseDiscount - virtualMoney - newDiscount);

      // return this.basicFare() - virtualMoney - newDiscount > 0
      //   ? this.basicFare() - virtualMoney - newDiscount
      //   : 0;
      return netFare - virtualMoney - newDiscount > 0 && !motDiscount
        ? netFare - virtualMoney - newDiscount
        : motDiscount
        ? 0
        : 0;
    } catch (e) {
      console.log(e);
    }
  };

  calculateNetFareUSD = () => {
    if (
      this.props.home &&
      this.props.home.metaData &&
      this.props.home.metaData.currency_conversions
    ) {
      console.log('try try calculate net fare------', this.calculateNetFare());
      console.log('try try this.props.home.metaData------', this.props.home.metaData);
      // return (
      //   this.calculateNetFare() * this.props.home.metaData.currency_conversions.clp_to_usd
      // ).toFixed('2');
      return (
        this.calculateNetFare() * this.props.home.metaData.currency_conversions.clp_to_usd
      ).toFixed('2');
    }
  };

  renderContactInputTable = () => {
    const { t } = this.props;
    return (
      <table className="passenger-input-personal-details">
        <tbody>
          <tr className="passenger-input-heading bold-text font10">
            <th className="emailinput">{t('PASSENGER_DETAILS.EMAIL_ID')}</th>
            <th className="email-input">{t('PASSENGER_DETAILS.EMAIL_CONFIRMATION')}</th>
            <th className="phone-input">{t('PASSENGER_DETAILS.PHONE_NUMBER')}</th>
          </tr>
          <tr className="passenger-input font10">
            <td className="email-input">
              <KuposInput
                className="kupos-border"
                type="email"
                value={
                  this.props.pbPaymentDetails.contactDetails
                    ? this.props.pbPaymentDetails.contactDetails.email
                    : ''
                }
                onChange={text => this.onInputChange(text, 'email')}
                onBlur={text => this.onInputBlurContact(text, 'email')}
                error={this.props.pbPaymentDetails.emailError ? true : false}
                errorMessage={
                  this.props.pbPaymentDetails.emailError
                    ? t(this.props.pbPaymentDetails.emailError.message)
                    : ''
                }
              />
            </td>
            <td className="email-input">
              <KuposInput
                className="kupos-border confirm-email"
                type="email"
                value={
                  this.props.pbPaymentDetails.contactDetails
                    ? this.props.pbPaymentDetails.contactDetails.confirmEmail
                    : ''
                }
                onChange={text => this.onInputChange(text, 'confirmEmail')}
                onBlur={text => this.onInputBlurContact(text, 'confirmEmail')}
                error={this.props.pbPaymentDetails.confirmEmailError ? true : false}
                errorMessage={
                  this.props.pbPaymentDetails.confirmEmailError
                    ? t(this.props.pbPaymentDetails.confirmEmailError.message)
                    : ''
                }
              />
            </td>
            <td className="phone-input">
              <KuposInput
                placeholder="9XXXXXXXX"
                className="kupos-border"
                type="tel"
                value={
                  this.props.pbPaymentDetails.contactDetails
                    ? this.props.pbPaymentDetails.contactDetails.mobile
                    : ''
                }
                onChange={text => this.onInputChange(text, 'mobile')}
                onBlur={text => this.onInputBlurContact(text, 'mobile')}
                error={this.props.pbPaymentDetails.mobileError ? true : false}
                errorMessage={
                  this.props.pbPaymentDetails.mobileError
                    ? t(this.props.pbPaymentDetails.mobileError.message)
                    : ''
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  onPaymentTypeSelect = paymentItem => {
    // this.setState({
    //   selectedPaymentGateway:
    //     this.state.selectedPaymentGateway == paymentItem.code ? null : paymentItem.code,
    // });

    console.log({ paymentItem });
    paymentItem
      ? this.setState({
          selectedPaymentGateway:
            this.state.selectedPaymentGateway == paymentItem.code ? null : paymentItem.code,
          cardChecked: false,
        })
      : this.setState({
          selectedPaymentGateway: 34,
          cardChecked: true,
        });
  };

  checkWallet = () => {
    if (CommonService.isLoggedIn(this.props.common.loginData)) {
      this.setState({ wallet: !this.state.wallet });
    } else {
    }
  };
  checkVirtual = () => {
    if (CommonService.isLoggedIn(this.props.common.loginData)) {
      this.setState({ virtual: !this.state.virtual });
    } else {
    }
  };

  applyPromoCode = () => {
    try {
      if (!this.state.promoCode) {
        this.setState({
          promoCodeError: {
            message: 'VALIDATIONS.VALID_PROMOTION',
          },
        });
        return;
      }
      let onwardSeatDetails = [];
      for (let s of this.props.pbPaymentDetails.passengerDetailsOnward) {
        onwardSeatDetails.push({
          id_type: s.idCardType.value,
          id_value: s.idCardNumber,
          seat_fare: s.fare,
          seat_no: s.floorNo + '_' + s.seatNumber, //floor number and seat number
        });
      }
      let returnSeatDetails = [];
      for (let s of this.props.pbPaymentDetails.passengerDetailsReturn) {
        returnSeatDetails.push({
          id_type: s.idCardType.value,
          id_value: s.idCardNumber,
          seat_fare: s.fare,
          seat_no: s.floorNo + '_' + s.seatNumber,
        });
      }
      let data = {
        promo_code: this.state.promoCode,
        amount: this.basicFare(),
        travel_date: this.props.home.onwardDate,
        origin_id: this.props.home.pbSourceCity.value,
        destination_id: this.props.home.pbDestinationCity.value,
        travel_id: this.props.pbServiceList.selectedServiceOnward.route.travel_id,
        is_mobile_app: 'true',
        extra_data_hash: {
          res_id: this.props.pbServiceList.selectedServiceOnward.route.id,
          return_res_id: this.props.home.returnPBDate
            ? this.props.pbServiceList.selectedServiceReturn.route.id
            : null,
          dep_time: this.props.pbServiceList.selectedServiceOnward.route.dep_time,
          return_dep_time: this.props.home.returnPBDate
            ? this.props.pbServiceList.selectedServiceReturn.route.dep_time
            : '',
          res_travel_id: this.props.pbServiceList.selectedServiceOnward.route.travel_id,
          r_res_travel_id: this.props.home.returnPBDate
            ? this.props.pbServiceList.selectedServiceReturn.route.travel_id
            : '',
          res_total_fare: this.props.pbServiceList.bookingDetailsOnward.netBookingAmount,
          r_res_total_fare: this.props.pbServiceList.bookingDetailsReturn.netBookingAmount,
        },
        onward_seats_info: onwardSeatDetails,
        return_seats_info: returnSeatDetails,
      };

      this.props.actions.applyPromoCode({ data: data }).then(res => {
        this.onPromoApply(res);
      });
    } catch (e) {
      console.log(e);
    }
    // this.props.applyPromoCode({callback:(result) => this.onPromoApply(result),data:data})
  };

  onPromoApply = result => {
    if (result) {
      if (result.status == 200) {
        this.setState({
          promoCodeApplied: true,
          promoCouponAmount: result.discount_amount,
          promoType: result.type,
          discountText: result.discount_text,
          showSuccessModel: true,
          successModelSuccess: true,
          successModelText: this.props.t('PASSENGER_DETAILS.PROMO_CODE_SUCCESS'),
        });
      } else {
        this.setState({
          promoCodeError: {
            message: result.message,
          },
          // showSuccessModel:true,
          // successModelSuccess:false,
          // showButton1:true,
          // showButton2:true,
          // successModelText:this.props.t("PASSENGER_DETAILS.PROMO_CODE_DOES_NOT_EXIST")
        });
      }
    }
  };

  promoCodeBlur = text => {
    if (!text) {
      this.setState({
        promoCodeError: {
          message: 'VALIDATIONS.VALID_PROMOTION',
        },
      });
    }
  };

  promoCodeChange = text => {
    this.setState({
      promoCodeError: null,
      promoCode: text,
    });
  };

  promoCheckboxChange = () => {
    this.setState({
      promoCodeChecked: !this.state.promoCodeChecked,
      promoCodeError: null,
      promoCode: '',
      promoCouponAmount: null,
      promoType: null,
      promoCodeApplied: false,
      discountText: null,
    });
  };

  onStepClick = menu => {
    if (!this.props.home.returnPBDate && menu == 3) {
      return;
    } else if (this.props.home.returnPBDate && menu == 4) {
      return;
    }
    try {
      if (this.props.home.returnPBDate && !this.state.status) {
        this.props.actions.setPassengerDetailsOnward(null);
        this.props.actions.setPassengerDetailsReturn(null);
        if (menu == 1) window.history.go(-2);
        else if (menu == 2) window.history.go(-1);
      } else if (!this.state.status) {
        this.props.actions.setPassengerDetailsOnward(null);
        if (menu == 1) window.history.go(-1);
      }
    } catch (e) {
      console.log(e);
    }
  };

  renderNotLoggedInBlock = () => {
    return (
      <div className="kupos-card dont-have-account-block flex-row">
        <div>
          <div className="heading bold font13">{this.props.t('PASSENGER_DETAILS.NO_ACCOUNT')}</div>
          <div className="font10">
            {this.props.t('PASSENGER_DETAILS.CREATE_YOURS_AND_GET_BENIFIT')}
          </div>
        </div>
        <div>
          <button className="kupos-button font12" onClick={() => this.openLoginModal()}>
            <span>{this.props.t('PASSENGER_DETAILS.CREATE_ACCOUNT')}</span>
          </button>
        </div>
      </div>
    );
  };

  openLoginModal = () => {
    this.props.actions.openCloseLoginModal(true);
  };

  cardChoosen = (val, key) => {
    this.setState({
      selectedCard: val,
      cardChecked: true,
    });
  };

  setMotData = data => {
    console.log('MOtdataindefaultPage', data);
    this.setState({ motData: data });
  };

  onConvenioSelect = idConvenio => {
    this.setState({ conveniosServiceLoading: true });
    this.props.actions.apiCall({ url: ApiUrls.getConveniosService(idConvenio), type: 'home' }).then(
      res => {
        if (res && res.data && res.data[0])
          this.setState({ convenioType: res.data[0].Tipo, conveniosServiceLoading: false });
      },
      err => {
        this.setState({ conveniosServiceLoading: false, convenioType: 'RUT' });
      },
    );
  };

  renderPetSeatInfo = seat => {
    return (
      seat.is_pet_seat && (
        <div className={'pet-seat-info font11'}>
          <img
            src="/images/seats/PetsOnBoardIIcon.svg"
            alt=""
            style={{ width: '34px', marginRight: '10px' }}
          />
          <span style={{ fontWeight: 'bold', marginRight: '15px' }}>Mascota: </span>
          <span>
            ({CommonService.getSeatName(seat.type)}, Asiento {seat.number})
          </span>
        </div>
      )
    );
  };
  renderPaymentMain = () => {
    const isOwnTravel =
      !this.props.home.metaData ||
      !this.props.home.metaData.pullman_travel_ids ||
      !this.props.pbServiceList.selectedServiceOnward.route ||
      this.props.home.metaData.pullman_travel_ids.includes(
        this.props.pbServiceList.selectedServiceOnward.route.travel_id,
      );

    let smartMilesDataDiscount = +(this.state.smartMilesData &&
    this.state.smartMilesData.total_redemption_amount
      ? this.state.smartMilesData.total_redemption_amount
      : 0);
    smartMilesDataDiscount =
      smartMilesDataDiscount > this.onwardBasicFare()
        ? this.onwardBasicFare()
        : smartMilesDataDiscount;
    return (
      <div className="pb-service-list-payment-details-page content-container flex-row passenger-and-payment-details-container">
        <div className="passenger-input-container">
          {!CommonService.isLoggedIn() ? this.renderNotLoggedInBlock() : null}
          <div className="kupos-card passenger-input-details">
            <div className="flex-row passenger-details-title-row">
              <div className="font13">
                {this.props.t('PASSENGER_DETAILS.PASSENGER_DETAIL.NORMAL')}
                <span className="bold font13">
                  {this.props.t('PASSENGER_DETAILS.PASSENGER_DETAIL.BOLD')}
                </span>
              </div>

              <div
                className="primary-text bold-text countdown-counter font13"
                style={{ position: 'relative' }}
              >
                {this.state.timeInfoHover ? (
                  <span
                    className="info-popup font10 normal-text"
                    style={
                      Number(this.state.countdown && this.state.countdown.split(':')[0]) < 3
                        ? {
                            top: -16,
                            right: 110,
                            width: '400%',
                            color: '#464647',
                            textAlign: 'center',
                          }
                        : {
                            top: -4,
                            right: 110,
                            width: '400%',
                            color: '#464647',
                            textAlign: 'center',
                          }
                    }
                  >
                    {Number(this.state.countdown && this.state.countdown.split(':')[0]) < 3
                      ? this.props.t('PROFILE.TIME_LEFT_LESS_THREE')
                      : this.props.t('PROFILE.TIME_LEFT_TO_PURCHASE')}
                  </span>
                ) : null}
                <img
                  onMouseEnter={() => this.setState({ timeInfoHover: true })}
                  onMouseLeave={() => this.setState({ timeInfoHover: false })}
                  src="/images/icons/icon-chronometer.png"
                  className="clock-over"
                  alt="clock-over"
                />
                <span>{this.state.countdown}</span>
              </div>
            </div>
            <div className="passenger-inputs-block">
              <span className="bold journey-type-title font10">
                {this.props.t('PASSENGER_DETAILS.GOING')}
              </span>
            </div>

            {this.props.pbServiceList &&
            this.props.pbServiceList.bookingDetailsOnward &&
            this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook ? (
              <BookingInput
                selectedSeatsToBook={
                  this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
                }
                idCardTypes={this.idCardTypes}
                countries={this.countries}
                passengerDetails={this.props.pbPaymentDetails.passengerDetailsOnward}
                onNameChange={(text, seat) => this.onNameChange(text, seat)}
                onLastNameChange={(text, seat) => this.onLastNameChange(text, seat)}
                onCountryChange={(val, seat) => this.onCountryChange(val, seat)}
                onIdCardChange={(label, seat) => this.onIdCardChange(label, seat)}
                onIdCardNumberChange={(text, seat) => this.onIdCardNumberChange(text, seat)}
                onInputBlur={(text, seat, inp) => this.onInputBlur(text, seat, inp)}
                nameError={this.props.pbPaymentDetails.nameError}
                last_nameError={this.props.pbPaymentDetails.lastNameError}
                // cardNumberError={this.state.cardNumberError}
                cardNumberError={this.props.pbPaymentDetails.rutError}
                seatsTitle="DATOS DEL PASAJERO (IDA)"
                t={this.props.t}
              />
            ) : null}

            {this.props.home.returnPBDate &&
            this.props.pbServiceList.bookingDetailsReturn &&
            this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook ? (
              <div>
                {!this.hasPetSeat() && (
                  <div className="passenger-inputs-block flex-row">
                    <span className="bold journey-type-title font10">
                      {this.props.t('RESULTS_PAGE.RETURN')}{' '}
                    </span>
                    <span className="font10">
                      <KuposCheckbox
                        checked={this.state.copyToReturnChecked}
                        onChange={this.copyToReturn}
                        label={this.props.t(
                          'PASSENGER_DETAILS.APPLY_SAME_PASSENGER_DETAILS_FOR_GOING_TRIP',
                        )}
                      />{' '}
                    </span>
                  </div>
                )}
                <BookingInput
                  selectedSeatsToBook={
                    this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
                  }
                  // disabled={this.state.copyToReturnChecked}
                  idCardTypes={this.idCardTypes}
                  countries={this.countries}
                  passengerDetails={this.props.pbPaymentDetails.passengerDetailsReturn}
                  onNameChange={(text, seat) => this.onNameChangeReturn(text, seat)}
                  onLastNameChange={(text, seat) => this.onLastNameChangeReturn(text, seat)}
                  onCountryChange={(val, seat) => this.onCountryChangeReturn(val, seat)}
                  onIdCardChange={(val, seat) => this.onIdCardChangeReturn(val, seat)}
                  onIdCardNumberChange={(text, seat) => this.onIdCardNumberChangeReturn(text, seat)}
                  onInputBlur={this.onInputBlurReturn}
                  nameError={this.state.nameReturnError}
                  last_nameError={this.state.last_nameReturnError}
                  cardNumberError={this.state.cardNumberReturnError}
                  seatsTitle="DATOS DEL PASAJERO (VUELTA)"
                  t={this.props.t}
                />
              </div>
            ) : null}
            {this.renderContactInputTable()}

            <div className="pet-seat-info-container">
              {this.props.pbServiceList &&
              this.props.pbServiceList.bookingDetailsOnward &&
              this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
                ? this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook.map((seat, i) =>
                    this.renderPetSeatInfo(seat, i),
                  )
                : null}

              {this.props.pbServiceList &&
              this.props.pbServiceList.bookingDetailsReturn &&
              this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
                ? this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook.map((seat, i) =>
                    this.renderPetSeatInfo(seat, i),
                  )
                : null}
            </div>
          </div>

          {this.props.home.is_mot === false &&
            this.props.pbPaymentDetails.conveniosList &&
            this.props.pbPaymentDetails.conveniosList.length &&
            isOwnTravel && (
              <ConveniosList
                onApplyDiscount={this.applyPullmanDiscount}
                pullmanDiscountError={this.state.pullmanDiscountError}
                setPullmanDiscountError={this.setPullmanDiscountError}
                isLoading={this.state.pullmanDiscountLoading}
                onSelect={this.onConvenioSelect}
                conveniosServiceLoading={this.state.conveniosServiceLoading}
                convenioType={this.state.convenioType}
              />
            )}

          {this.state.showPaymentsOptions && (
            <PaymentOptions
              isOwnTravel={isOwnTravel}
              operatorTnc={this.state.operatorTnc}
              paymentGatewayList={isOwnTravel ? this.paymentGatewayListV1 : this.paymentGatewayList}
              selected={this.state.selectedPaymentGateway}
              onPaymentSelect={this.onPaymentTypeSelect}
              walletChecked={this.state.wallet}
              virtualChecked={this.state.virtual}
              walletMoney={
                this.props.common.loginData && this.props.common.loginData.balances
                  ? this.props.common.loginData.balances.clp.money
                  : ''
              }
              virtualMoney={
                this.props.common.loginData && this.props.common.loginData.balances
                  ? this.props.common.loginData.balances.clp.credit
                  : ''
              }
              isLoggedIn={
                this.props.common.loginData && this.props.common.loginData.auth_token ? true : false
              }
              checkWallet={this.checkWallet}
              checkVirtual={this.checkVirtual}
              onPay={this.onSubmit}
              bookTicketPending={this.props.pbPaymentDetails.bookTicketPending}
              bookingError={this.state.bookingError}
              onBookingErrorClick={() => this.setState({ bookingError: null })}
              onPromoCheckboxChange={this.promoCheckboxChange}
              promoCodeChecked={this.state.promoCodeChecked}
              onPromoCodeChange={this.promoCodeChange}
              onPromoCodeBlur={this.promoCodeBlur}
              applyPromoCodePending={this.props.pbPaymentDetails.applyPromoCodePending}
              onApplyPromoCode={this.applyPromoCode}
              promoCodeError={
                this.state.promoCodeError ? this.props.t(this.state.promoCodeError.message) : null
              }
              t={this.props.t}
              history={this.props.history}
              tncChecked={this.state.tncChecked ? true : false}
              onTncChange={() => this.setState({ tncChecked: !this.state.tncChecked })}
              totalAmount={this.calculateNetFare}
              showKuposPay={true}
              showPaypal={true}
              showPromocode={true}
              showBancoEstado={true}
              corporateDiscountState={this.state.corporateDiscountState}
              instantDiscount={this.state.instantDiscount}
              myCards={this.state.myCards ? this.state.myCards : null}
              cardTypes={this.state.oneClickCardTypes ? this.state.oneClickCardTypes : null}
              cardChoosen={this.cardChoosen}
              cardChecked={this.state.cardChecked}
              isOneClickEnabled={this.state.isOneClickEnabled}
              selectedServiceRouteOnward={this.props.pbServiceList.selectedServiceOnward.route}
              selectedServiceRouteReturn={this.props.pbServiceList.selectedServiceReturn.route}
              is_mot={this.props.home.is_mot}
              actions={this.props.actions}
              setMotData={this.setMotData}
              hidePG={smartMilesDataDiscount >= this.basicFare()}
            />
          )}
        </div>
        <div
          style={{
            position: 'relative',
            width: 325,
          }}
        >
          <PaymentRightSideBar
            wallet={this.state.wallet}
            virtual={this.state.virtual}
            walletMoneyAdded={this.walletMoneyAdded}
            virtualMoneyAmount={this.virtualMoneyAmount}
            basicFare={this.basicFare}
            onwardBasicFare={this.onwardBasicFare}
            originalBaseFare={this.originalBaseFare}
            calculateNetFare={this.calculateNetFare}
            calculateNetFareUSD={this.calculateNetFareUSD}
            promoCode={this.state.promoCode}
            onPromoRemove={this.promoCheckboxChange}
            promoCouponAmount={this.state.promoCouponAmount}
            showUsd={this.state.selectedPaymentGateway == 23 ? true : false}
            corporateDiscountState={this.state.corporateDiscountState}
            instantDiscount={this.state.instantDiscount}
            pullmanDiscountApplied={this.state.pullmanDiscountApplied}
            ftmDiscount={this.state.smartMilesData}
            t={this.props.t}
            is_mot={this.props.home.is_mot}
            motData={this.state.motData}
          />
        </div>
      </div>
    );
  };

  renderBookingConfirmation = () => {
    if (this.state.status == 'success') {
      return (
        <BookingSuccess
          pnrNumber={this.state.pnrNumber}
          loading={this.props.common.loadTicketDetailsPending}
          ticketDetails={this.props.common.ticketDetails}
          history={this.props.history}
          success={true}
          t={this.props.t}
          appType={localStorage.getItem('appType')}
        />
      );
    } else if (this.state.status == 'failure') {
      return <BookingSuccess success={false} />;
    }
  };

  goToPaymentGateway = () => {
    localStorage.setItem('paymentGatewayOpened', true);
    document.write(this.state.paymentGatewayString);
  };

  goToCoachLoayout = () => {
    let serviceData = {
      ...this.props.home,
      ...this.props.pbServiceList,
      ...this.props.pbPaymentDetails,
    };
    if (serviceData.returnPBDate) {
      window.history.go(-2);
      CommonService.passengerDetailsReturn = CommonService.copyObject(
        serviceData.passengerDetailsReturn,
      );
    } else {
      // this.props.history.goBack();
      window.history.go(-1);
    }
  };

  render() {
    const { t } = this.props;

    //deduce the data for fare change popup
    let fareChangeData = this.state.showFareDifferenceBody
      ? this.state.showFareDifferenceBody
      : null;

    var result = fareChangeData
      ? Object.keys(fareChangeData).map(key => [key, fareChangeData[key]])
      : null;

    var onwardData = result ? result[0][1] : null;
    var onwardArray = onwardData
      ? Object.keys(onwardData).map(key => [key, onwardData[key]])
      : null;

    let returnData = result ? result[1][1] : null;
    var returnArray = returnData
      ? Object.keys(returnData).map(key => [key, returnData[key]])
      : null;

    console.log('is_mot', this.props.home.is_mot);

    return (
      <div className="pb-payment-details-default-page">
        <div className="content-container">
          <KuposSteps
            menuButtons={this.state.stepsMenu}
            t={this.props.t}
            onStepClick={this.onStepClick}
          />
        </div>
        {!this.state.status ? this.renderPaymentMain() : this.renderBookingConfirmation()}

        <KuposErrorSuccessModal
          showModal={this.state.showSuccessModel}
          success={this.state.successModelSuccess}
          bodyText={this.state.successModelText}
          onButtonClick={
            this.state.onModalOkClick
              ? this.state.onModalOkClick
              : () => this.setState({ showSuccessModel: false, successModelText: null })
          }
          showButton1={this.state.showButton1}
          buttonText1={'OK, VOLVER'}
          onButtonClick1={
            this.state.onModalOkClick
              ? this.state.onModalOkClick
              : () =>
                  this.setState({
                    showSuccessModel: false,
                    successModelText: null,
                    showButton1: false,
                    showButton2: false,
                  })
          }
          showButton2={this.state.showButton2}
          buttonText2={'CONTÁCTANOS'}
          onButtonClick2={() => this.props.history.push('/pages/contact')}
        />
        <KuposModalWithButtons
          size="md"
          showButton1={true}
          showModal={this.state.showErrorsModal}
          onHide={() => this.setState({ showErrorsModal: false })}
        >
          {<span className="font11">{this.state.error}</span>}
        </KuposModalWithButtons>

        <KuposModalWithButtons
          size="md"
          showButton1={true}
          showButton2={true}
          showModal={this.state.showFareDifferenceModal}
          // showModal={true}
          title={t('TRANSLATIONS.IMP_INFO')}
          subTitle={t('TRANSLATIONS.SEAT_PRICE_CHANGE')}
          buttonText1={t('TRANSLATIONS.CONT_WITH_PAYMENT')}
          buttonText2={t('TRANSLATIONS.SELECT_ANOTHER_SEAT')}
          subTitleStyle={{ marginTop: 20 }}
          icon={'/svgs/exclamation-mark.svg'}
          onHide={() => this.setState({ showFareDifferenceModal: false })}
          onButtonClick1={this.goToPaymentGateway}
          onButtonClick2={this.goToCoachLoayout}
        >
          {
            <div
              className="font11"
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              {/* <span className="bold-text">
                {onwardArray ? 'Onward Seat: ' + onwardArray[0][0] : ''}
              </span> */}

              <div>
                <span>
                  {t('TRANSLATIONS.OLD_PRICE') + ': '}
                  <span className="strike-out-text">
                    {onwardArray ? CommonService.currency(onwardArray[0][1].ui_fare) : ''}
                  </span>
                </span>

                {/* <span>{onwardArray ? 'Original price: ' + onwardArray[0][1].ui_fare : ''}</span> */}
              </div>
              <div style={{ marginTop: 10 }}>
                <span className="bold-text">
                  {onwardArray
                    ? t('TRANSLATIONS.NEW_PRICE') +
                      ': ' +
                      CommonService.currency(onwardArray[0][1].gds_fare)
                    : ''}
                </span>

                {/* <span>{onwardArray ? 'Changed price: ' + onwardArray[0][1].gds_fare : ''}</span> */}
              </div>
            </div>
          }
        </KuposModalWithButtons>
        <KuposModalWithButtons
          size="md"
          showButton1={true}
          buttonText1={this.props.t('PROFILE.BACK_TO_RESULTS')}
          showModal={this.state.showTimeUpModal}
          onHide={() => {
            sessionStorage.removeItem('paymentCounter');
            this.props.history.replace('', null);
            // this.props.history.push('/');
            window.location = '/';
          }}
          icon="/images/icons/timeup.png"
          title={this.props.t('HOME.WE_ARE_SORRY')}
          bodyText={this.props.t('PROFILE.PAYMENT_EXPIRY')}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    pbPaymentDetails: state.pbPaymentDetails,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...actions, ...homeActions, ...serviceActions, ...commonActions },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/DefaultPage.js